import React, { useState, useEffect, useRef, Fragment } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Button, FormGroup, Label, Input, Alert, Modal, ModalHeader,
    ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import '../estilos.css';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import Moment from 'moment';
//import {API } from 'aws-amplify';
import { onCreatePProduccion, onCreatePProduccionGeneral, onCreatePlaneacionBase, onDeletePProduccion, onDeletePProduccionGeneral, onDeletePlaneacionBase, onDeleteRecibaSeriales, onUpdatePProduccion, onUpdatePProduccionGeneral, onUpdatePlaneacionBase, onUpdateRecibaSeriales } from '../../graphql/subscriptions';
import { listPlaneacionBaseUltimoNumeros } from '../../graphql/queries';
import * as xlsx from "xlsx";
import {
    updatePlaneacionBaseUltimoNumero,
    createPlaneacionBaseUltimoNumero,
    createPlaneacionBaseGeneral,
    updatePlaneacionBaseGeneral,
    createPlaneacionBase,
    updatePlaneacionBase
} from '../../graphql/mutations';
import { useReactToPrint } from 'react-to-print';
import {
    GetAutorizaciones, GetClientes, GetPlaneacion, GetPlaneacionBase, GetPlaneacionBaseGeneral, GetPlaneacionBaseGeneralID, GetPlaneacionGeneral,
    GetPlaneacionGeneralID, GetPlaneacionID, GetPProduccion, GetPProduccionGeneral,
    GetPProduccionGeneralID, GetProductos, GetRecibaSeriales, GetRecibaSerialesID,
    GetRecibaSerialesIDMP, GetRecibaSerialesMP, GetUsuarios
} from '../queries/Queries';
import { ObtenerSerialesPlaneacionBase, combinarIDS, seguimientoProduccion } from '../queries/DCUbicaciones';
import CometariosPB from './CometariosPB';
import { manageResumenOperacion } from '../queries/Mutations';
import { generateClient } from "aws-amplify/api";

const API = generateClient();


const initialfFormState = { formType: 'PlaneaciónBase' }
function PlaneacionB() {
    const [clientes, setClientes] = useState([]);
    const [productosSinFiltro, setProductosSinFiltro] = useState([]);
    const [reciba, setReciba] = useState([]);
    const [recibaFiltrado, setReFiltrado] = useState([]);
    const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
    const [planeacionSinFiltro, setPlaneacionSinFiltro] = useState([]);
    const [planeaciones, setPlaneaciones] = useState([]);
    const [editar, setEditar] = useState(false);
    const [numeroP, setNumeroP] = useState(0);
    const [ultimoNumeroP, setultimoNumeroP] = useState(0);
    const [formState, updateFormState] = useState(initialfFormState);
    const [isDisabled, setisDisabled] = useState(false);
    const [buscarporFecha, setBuscarporFecha] = useState(true);
    const [estadoReciba, setEstadoReciba] = useState("todos");
    const [search, setSearch] = useState("");
    const [fechaPBusqueda, setFechaPBusqueda] = useState("");
    const [comentariosNoFIFO, setComentariosNoFIFO] = useState("");
    const [usuarioAutNoFIFO, setUsuarioAutNoFIFO] = useState("");
    const [searchBy, setSearchBy] = useState("cliente");
    const [totalRecords, setTotalRecords] = useState(0);
    const [faltanDatos, setFaltanDatos] = useState(true);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("No fue posible realizar la operación, error indeterminado: revise su conexión a internet, recargue la página y vuelva a intentarlo, si el error persiste, favor de comunicarse a sistemas");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pplaneacion = window.$Planeacion ? window.$Planeacion : false;
    const verpplaneacion = window.$verPlaneacion ? window.$verPlaneacion : false;
    const verpplaneacionbase = window.$verPlaneacionBase ? window.$verPlaneacionBase : false;
    const vpreciounitario = window.$VerPrecioUnitario ? window.$VerPrecioUnitario : false;
    const [agregarComentariosPPB, setAgregarComentariosPPB] = useState(false);
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [cargando1, setCargando1] = useState(false);
    const [fechaPlaneacion, setFechaPlaneacion] = useState("");
    const [fechaPlaneacionM, setFechaPlaneacionM] = useState("");
    const [sumProduccion, setSumProduccion] = useState("");
    const [sumProduccionp, setSumProduccionp] = useState("");
    const [sumCiclos, setSumCiclos] = useState("");
    const [vistaNumeroParte, setVistaNumeroParte] = useState(false);
    const [verSeguimiento, setVerSeguimiento] = useState((pplaneacion === false && verpplaneacion === false && verpplaneacionbase === true) ? true : false);
    const [verCantidadAlmacen, setVerCantidadAlmacen] = useState(false);
    const [precioUnitario, setPrecioUnitario] = useState(false);
    const [precioUnitarioPC, setPrecioUnitarioPC] = useState(false);
    const [precioUnitarioP, setPrecioUnitarioP] = useState(false);
    const [sumICiclos, setSumICiclos] = useState("");
    const [sumCostoTotal, setSumCostoTotal] = useState("");
    const onDismiss = () => setAVisible(false);
    const [inputList, setInputList] = useState([]);
    const [activeTab, setActiveTab] = useState('1');
    const [paginas, setPaginas] = useState([]);
    const [usariosNC, setUsuariosNC] = useState([]);
    const [noFIFOUsuarios, setNOFIFOUsuarios] = useState([]);
    const [rPANOFIFO, setRPANOFIFO] = useState("");
    const [modal, setModal] = useState(false);
    const [precioUnitarioImp, setPrecioUnitarioIMP] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [vistaUltimoAP, setVistaUltimoAP] = useState(false);
    const [sumPorcentajeT, setSumPorcentajeT] = useState(0);
    const [sumPorcentajeC, setSumPorcentajeC] = useState(0);
    const [sumPorcentajeTPC, setSumPorcentajeTPC] = useState(0);
    const [sumPorcentajeCPC, setSumPorcentajeCPC] = useState(0);
    const [planeacionSinFIFO, setPlaneacionSinFIFO] = useState(false);
    const [modificados, setModificados] = useState([]);
    const [textPQR, setPQR] = useState("Con código QR");

    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();
    var cincoDias = new Date();
    //now2.setMonth(now2.getMonth() - 1);
    now2.setDate(now2.getDate() - 1);
    now.setDate(now.getDate() + 5);
    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));


    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    }

    const toggle = () => setModal(!modal);
    const toggle2 = () => setModal2(!modal2);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    // current page
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPagePlaneacion, setCurrentPagePlaneacion] = useState(1);

    // total records per page to display
    const recordPerPage = 20;

    // range of pages in paginator
    const pageRange = 5;


    // handle change event
    function handlePageChange(pageNumber) {
        setAVisible(false);
        setCargando(false)
        setCurrentPage(pageNumber);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, pageNumber, vistaUltimoAP);
    }

    // handle change event
    function handlePageChangePlaneacion(pageNumber) {
        window.scrollTo(0, 0);
        setCargando(true);
        setAVisible(false);
        setCurrentPagePlaneacion(pageNumber);
        busquedaPlaneacion(planeacionSinFiltro, pageNumber, fechaPBusqueda, vistaNumeroParte, verSeguimiento);
    }


    async function busquedaPlaneacion(planeacionsg, currentPage, fechaBusqueda, vistaNP, vSeguimiento) {
        try {
            var paginasp = [];
            var p = 0;
            var pi = 1;
            var racks = 0;
            var ciclos = 0;
            var costoTotalP = 0;
            var costoTotalD = 0;
            var costoTotalE = 0;
            var costoTotalPVS = 0;
            var costoTotalDVS = 0;
            var costoTotalEVS = 0;
            var sumRacksSPB = 0;
            var ciclosSPB = 0;
            //Se filtran los datos por los parámetros establecidos
            /*planeacionsg = await planeacionsg.filter(planeacion => fechaBusqueda ? planeacion.fechaDePlaneacion === fechaBusqueda :
               planeacion.fechaDePlaneacion === planeacion.fechaDePlaneacion);  */

            //Si existen planeaciones a mostrar          
            if (planeacionsg.length > 0) {
                //Se obtienen el número de páginas correspondientes
                await Promise.all(planeacionsg.map(async planeacion => {
                    if (planeacion.numero !== p) {
                        paginasp.push({ pagina: pi, paginareal: planeacion.numero });
                        p = planeacion.numero;
                        pi++;
                        planeacion.paginacion = pi - 1;
                    }
                    return planeacion;
                }));
                //Se filtran los datos por la página solicitada
                planeacionsg = planeacionsg.filter(planeacion => planeacionsg.length === 1 ? planeacion.paginacion === planeacion.paginacion :
                    planeacion.paginacion === currentPage);
                const pb = planeacionsg[0].PlaneacionBIDS ? await ObtenerSerialesPlaneacionBase(planeacionsg[0].PlaneacionBIDS) : [];
                var planeacionsf = pb.planeacionBase ? pb.planeacionBase : [];
                //var planeacionsf = await ObtenerSerialesPlaneacionBase(planeacionsg[0].PlaneacionBIDS);
                if (currentPage < 1) {
                    currentPage = 1;
                    setCurrentPagePlaneacion(1);
                }

                if (currentPage > pi - 1) {
                    currentPage = currentPage - 1;
                    setCurrentPagePlaneacion(currentPage);
                }
                //Ver seguimiento en plan de producción.
                const planeacionb = planeacionsf.sort((a, b) =>
                    (a.cliente + a.prioridad) > (b.cliente + b.prioridad) ? 1 : (a.cliente + a.prioridad) < (b.cliente + b.prioridad) ? -1 : 0);
                if (planeacionb.length)
                    setFechaPlaneacionM(planeacionb[0].fechaDePlaneacion);

                racks = pb.racks;
                ciclos = pb.ciclos;
                costoTotalD = pb.costoTotalD;
                costoTotalE = pb.costoTotalE;
                costoTotalP = pb.costoTotalP;
                /* await Promise.all(planeacionb.map(async planeacion => {
                     planeacion.color = "";
                     racks += parseFloat(planeacion.racks);
                     ciclos += parseFloat(planeacion.ciclos);
                     if (planeacion.divisa === "Dólar")
                         costoTotalD += parseFloat((planeacion.precioUnitario ? planeacion.precioUnitario : 0) * planeacion.cantidadPiezas);
                     if (planeacion.divisa === "Euro")
                         costoTotalE += parseFloat((planeacion.precioUnitario ? planeacion.precioUnitario : 0) * planeacion.cantidadPiezas);
                     if (planeacion.divisa === "Peso mexicano")
                         costoTotalP += parseFloat((planeacion.precioUnitario ? planeacion.precioUnitario : 0) * planeacion.cantidadPiezas);
                     return planeacion;
                 }));*/

                if (vSeguimiento) {
                    const seguimiento = await seguimientoProduccion(planeacionsf);
                    costoTotalPVS = seguimiento.costoTotalPVS;
                    costoTotalDVS = seguimiento.costoTotalDVS;
                    costoTotalEVS = seguimiento.costoTotalEVS;
                    setSumPorcentajeT(seguimiento.sumPorcentajeT);
                    setSumPorcentajeC(seguimiento.sumPorcentajeC);
                    setSumPorcentajeTPC(seguimiento.sumPorcentajeTPC);
                    setSumPorcentajeCPC(seguimiento.sumPorcentajeCPC);
                    planeacionsf = seguimiento.planeacionsf;
                    ciclosSPB = seguimiento.ciclosSPB;
                    sumRacksSPB = seguimiento.sumRacksSPB;
                } else {
                    setSumPorcentajeT(0);
                    setSumPorcentajeC(0);
                    setSumPorcentajeTPC(0);
                    setSumPorcentajeCPC(0);
                }
                setultimoNumeroP(pi - 1);

                ///Datos de racks y ciclos
                if (racks > 0)
                    setSumProduccion((sumRacksSPB > 0 ? (sumRacksSPB.toFixed(2) + "/") : "") + racks.toFixed(2) + " RACKS " + (sumRacksSPB > 0 ? (((sumRacksSPB / 19).toFixed(2)) + "/") : "") + (racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN")
                else
                    setSumProduccion("");

                if (ciclos > 0)
                    setSumICiclos((ciclosSPB > 0 ? (ciclosSPB + "/") : "") + ciclos + " CICLOS")
                else
                    setSumICiclos("");
                const costoTotal = costoTotalD
                if (costoTotalD > 0 || costoTotalE > 0 || costoTotalP > 0)
                    setSumCostoTotal("COSTO TOTAL:" + ((costoTotalD > 0 ? " $" + (costoTotalDVS > 0 ? (costoTotalDVS.toFixed(2) + "/") : "") + costoTotalD.toFixed(2) + " DÓLARES" : "") +
                        (costoTotalE > 0 ? " $" + (costoTotalEVS > 0 ? (costoTotalEVS.toFixed(2) + "/") : "") + costoTotalE.toFixed(2) + " EUROS" : "") + (costoTotalP > 0 ? " $" + (costoTotalPVS > 0 ? (costoTotalPVS.toFixed(2) + "/") : "") + costoTotalP.toFixed(2) + " PESOS MEXICANOS" : "")));
                else
                    setSumCostoTotal("");

                const planeacioncp = planeacionsf.sort((a, b) =>
                    (a.cliente + a.prioridad) > (b.cliente + b.prioridad) ? 1 : (a.cliente + a.prioridad) < (b.cliente + b.prioridad) ? -1 : 0);
                setPlaneaciones(planeacioncp);
                const Pcoat = planeacioncp.filter(proceso => proceso.Pcoat === true);
                const Ecoat = planeacioncp.filter(proceso => proceso.Ecoat === true);
                const Platinado = planeacioncp.filter(proceso => proceso.Platinado === true);
                setPrecioUnitarioPC(Pcoat.length > 0 ? true : false);
                setPrecioUnitario(Ecoat.length > 0 ? true : false);
                setPrecioUnitarioP(Platinado.length > 0 ? true : false);
                //var worksheet = xlsx.utils.json_to_sheet(planeacioncp, { skipHeader: false });
                //navigator.clipboard.writeText(xlsx.utils.sheet_to_csv(worksheet));
                setPaginas(paginasp);
            } else {
                setSumICiclos("");
                setSumProduccion("");
                setSumCostoTotal("");
                setPlaneaciones([]);
                setPaginas([]);
                setPrecioUnitarioPC(false);
                setPrecioUnitario(false);
                setPrecioUnitarioP(false);
            }
            setCargando(false);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("Error: " + JSON.stringify(e));
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }
    }
    async function busqueda(recibasinf, estadoReciba, searchb, search, currentPage, vistaUAP) {
        var pag = 1;
        var bandera = 1;
        var num = 0;
        //Se revisa el tipo de vista que se requiere de los datos        
        var recibaFromAPI = vistaUAP === true ? recibasinf.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0) :
            recibasinf.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
        //Se agrega el número de registro y se ponen los datos en reciba sin filtro
        await Promise.all(recibaFromAPI.map(async reciba => {
            reciba.registro = num;
            num++;
            return reciba;
        }));
        // se asigna a setRecibaSinFiltro los datos sin filtrado por piezasenAlmacen
        setRecibaSinFiltro(recibaFromAPI);
        // se asigna a setReFiltrado los datos filtrados por piezasenAlmacen: {gt: 0}
        recibaFromAPI = recibaFromAPI.filter(reciba => reciba.piezasenAlmacen > 0);
        setReFiltrado(recibaFromAPI);

        //Filtrado de datos por la búsqueda y el estado de reciba
        recibaFromAPI = recibaFromAPI.filter(reciba => parseInt(parseInt(reciba.cantidadRecibida) - parseInt(reciba.cantidadPlaneada ? reciba.cantidadPlaneada : 0)) > 0).filter(reciba =>
            estadoReciba === "todos" ? reciba.status === reciba.status : reciba.status === estadoReciba).filter(reciba =>
                searchb === "numero de parte" ? reciba.numerodeParte.toLowerCase().includes(search.toLowerCase()) :
                    searchb === "cliente" ? reciba.cliente.toLowerCase().includes(search.toLowerCase()) :
                        searchb === "id de reciba" ? reciba.numero.toLowerCase().includes(search.toLowerCase()) :
                            searchb === "serial" ? reciba.serial.toLowerCase().includes(search.toLowerCase()) :
                                searchb === "serial BTI" ? reciba.serialRecibaBTI ? reciba.serialRecibaBTI.toLowerCase().includes(
                                    search.toLowerCase()) : "".includes(search.toLowerCase()) :
                                    searchb === "paking" ? reciba.packing.toLowerCase().includes(search.toLowerCase()) :
                                        searchb === 'lote' ? reciba.lote.toLowerCase().includes(search.toLowerCase()) :
                                            reciba.fechayHoraDeReciba.includes(Moment(search).format("DD/MM/YYYY")));




        await Promise.all(recibaFromAPI.map(async reciba => {
            const restFechas = (new Date()).getTime() - (new Date(reciba.fechaDeReciba)).getTime();
            reciba.FEPlanta = Math.round(restFechas / (1000 * 60 * 60 * 24));
            reciba.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }

            return reciba;
        }))


        const lengthreciba = recibaFromAPI.length;
        if (lengthreciba <= 0)
            setCurrentPage(1);

        setReciba(recibaFromAPI.filter(reciba => reciba.indexpag === currentPage));
        setTotalRecords(lengthreciba);

        if (currentPage > 1 && lengthreciba > 0) {
            const prepaginas = parseInt(lengthreciba / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthreciba ? prepaginas + 1 : prepaginas;
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const recibaFromAPIp = recibaFromAPI.filter(reciba =>
                    reciba.indexpag === paginas);
                setReciba(recibaFromAPIp);
            }
        }
        setCargando1(false);
    }
    //Método useEffect
    useEffect(() => {
        if (verpplaneacionbase === true) {
            subscriptions();
        }
        fetchClientes();
        fetchPlaneaciones(rfechaini, rfechafin);
        fetchUsuario();
        fetchProductos();
    }, []);

    //Función que crea las subscripciones
    function subscriptions() {
        //se suscriben para los cambios en planeación base
        const fechaPlaneacion = Moment(new Date()).format("YYYY-MM-DD");
        const variables = {
            filter: {
                // filtro en base a la fecha de planeación.
                fechaDePlaneacion: { eq: fechaPlaneacion }
            }
        };
        // filtro en base a la fecha de planeación.
        const variables2 = {
            filter: {
                or: [{
                    inspeccionesFechaHora: {
                        contains: fechaPlaneacion
                    }
                },
                {
                    calidadFechaHora: {
                        contains: fechaPlaneacion
                    }
                },
                {
                    pintadoFechaHora: {
                        contains: fechaPlaneacion
                    }
                },
                {
                    noAceptadasFechaHora: {
                        contains: fechaPlaneacion
                    }
                }]
            }
        };
        //Subscripciones de la planeación base
        API.graphql({ query: onUpdatePlaneacionBase, variables }).subscribe({
            next: ({ provider, value }) => recargarPlanecionBS(), //value.data.onUpdatePlaneacionBase
            error: (error) => console.warn(error)
        });

        API.graphql({ query: onCreatePlaneacionBase, variables }).subscribe({
            next: ({ provider, value }) => recargarPlanecionBS(), //value.data.onUpdatePlaneacionBase
            error: (error) => console.warn(error)
        });

        API.graphql({ query: onDeletePlaneacionBase, variables }).subscribe({
            next: ({ provider, value }) => recargarPlanecionBS(), //value.data.onUpdatePlaneacionBase
            error: (error) => console.warn(error)
        });
        //Subscripciones del plan de producción
        API.graphql({ query: onUpdateRecibaSeriales, variables2 }).subscribe({
            next: ({ provider, value }) => recargarPlanecionBS(), //value.data.onUpdatePlaneacionBase
            error: (error) => console.warn(error)
        });

        API.graphql({ query: onDeleteRecibaSeriales, variables2 }).subscribe({
            next: ({ provider, value }) => recargarPlanecionBS(), //value.data.onUpdatePlaneacionBase
            error: (error) => console.warn(error)
        });

    }
    //Función que crea las subscripciones
    function recargarPlanecionBS() {
        if (editar === false) {
            fetchPlaneaciones(rfechaini, rfechafin);
        }
    }

    //Obtiene los datos guardados de los clientes
    async function fetchClientes() {

        //Filtro por cliente activo
        let filter = {
            activo: {
                eq: true
            }
        }

        //Se obtienen los datos de los clientes
        const apiData = await GetClientes(filter);

        setClientes(apiData);

    }

    //Obtiene los datos guardados de las planeaciones
    async function fetchPlaneaciones(fechainicial, fechafinal) {
        //Filtro por planeación activa
        window.scrollTo(0, 0);
        setCargando(true);
        setInputList([]);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                fechaDePlaneacion: {
                    ge: fechainicial
                }
            },
            {
                fechaDePlaneacion: {
                    le: fechafinal
                }
            }]
        }

        //Se obtienen los datos de la planeación
        const apiData = await GetPlaneacionBaseGeneral(filter);

        //Se obtienen los datos de la planeación
        //const apiData = await GetPlaneacion(filter);
        const planeacionesFromAPI = apiData.filter(planeacion => planeacion.PlaneacionBIDS.length > 0).sort((a, b) =>
            a.fechaDePlaneacion < b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion > b.fechaDePlaneacion ? -1 : 0);
        setPlaneacionSinFiltro(planeacionesFromAPI);
        busquedaPlaneacion(planeacionesFromAPI, currentPagePlaneacion, fechaPBusqueda, vistaNumeroParte, verSeguimiento);
    }
    //Obtiene los datos guardados de los productos
    async function fetchProductos() {
        //Se obtienen los datos de productos
        const apiData = await GetProductos();
        setProductosSinFiltro(apiData);
        //return apiData;
    }
    //Obtiene los datos guardados de Reciba
    async function fetchReciba() {
        setCargando(true);
        let filter = {
            and: [
                {
                    activo: {
                        eq: true
                    }
                },
                {
                    piezasenAlmacen: {
                        gt: 0,
                    },
                },]
        }

        //Se obtienen los datos de los seriales
        const apiData = await GetRecibaSerialesMP(filter);
        const recibaFromAPI = apiData.filter(reciba => reciba.cantidadRecibida > (reciba.cantidadPlaneada ? reciba.cantidadPlaneada : 0)).sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);
        setReciba(recibaFromAPI);
        setCargando(false)
        //busqueda(recibaFromAPI, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
        //return recibaFromAPI;
    }

    //Obtiene los usuarios activos con permisos para autorizar no usar FIFO en planeación.
    async function fetchUsuario() {
        //Filtro por usuarios activos        
        let filter = {
            activo: {
                eq: true
            }
        }
        //Se obtienen los datos de los usuarios
        const apiData = await GetUsuarios(filter);
        //Se ordenan los datos por el campo orden
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        const usuarioLG = dataFromAPI.filter(usuarios => usuarios.usuario === userName);
        setUsuariosNC(usuarioLG[0] ? usuarioLG[0].nombreCompleto : "");
        setPlaneacionSinFIFO(usuarioLG[0] ? usuarioLG[0].PlaneacionSinFIFO ? usuarioLG[0].PlaneacionSinFIFO : false : false);
        setNOFIFOUsuarios(dataFromAPI.filter(usuarios => usuarios.PlaneacionAutNoFIFO === true));
        setAgregarComentariosPPB(usuarioLG[0] ? usuarioLG[0].AgregarComentariosPPB ? usuarioLG[0].AgregarComentariosPPB : false : false)
    }



    //Obtiene los datos de la última ubicación del material guardados en recibaSeriales
    function obtenerUltimaUbicacionPlaneacion(ubicacion) {
        var locaciones = "";
        var locacion = "";
        if (ubicacion) {
            ubicacion.map(x => (
                locacion = "",
                locacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', ''),
                locaciones = locacion === "" ? locaciones : locaciones === "" ? locacion : locaciones + ", " + locacion
            ));
        }
        return locaciones;
    }
    function buscarpor(e) {
        setAVisible(false);
        setSearchBy(e.target.value);
        if (search && e.target.value !== "fecha")
            busqueda(recibaSinFiltro, estadoReciba, e.target.value, search, currentPage, vistaUltimoAP);
    };
    function onSearch(e) {
        setAVisible(false);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
    };
    function onSearchFecha(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, e.target.value, currentPage, vistaUltimoAP);
    };
    function onSearchFechaPlaneacion(e) {
        setAVisible(false);
        window.scrollTo(0, 0);
        setCargando(true);
        setFechaPBusqueda(e.target.value);
        // busquedaPlaneacion(planeacionSinFiltro, currentPagePlaneacion, e.target.value, vistaNumeroParte, verSeguimiento);
        fetchPlaneaciones(e.target.value, e.target.value);
    };
    function clicBuscarporFecha(e) {
        setAVisible(false);
        setBuscarporFecha(!buscarporFecha);
        if (!buscarporFecha === false) {
            if (fechaPBusqueda !== "") {
                setFechaPBusqueda("");
                //busquedaPlaneacion(planeacionSinFiltro, currentPagePlaneacion, "", vistaNumeroParte, verSeguimiento);
                fetchPlaneaciones(rfechaini, rfechafin);
            }
        }
    };
    async function onChangeCliente(e, i) {
        const list = [...inputList];
        const { name, value } = e.target;
        const clienteFromAPI = clientes.filter(cliente => cliente.id === e.target.value);
        await Promise.all(clienteFromAPI.map(async cliente => {
            list[i][name] = value;
            list[i].cliente = cliente.cliente;
            list[i].descripcion = "";
            list[i].rackTipo = "";
            list[i].productoID = "";
            list[i].numerodeParte = "";
        }));
        //setProductos(await fetchProductos(e.target.value));
        const Pcoat = list.filter(proceso => proceso.Pcoat === true);
        const Ecoat = list.filter(proceso => proceso.Ecoat === true);
        const Platinado = list.filter(proceso => proceso.Platinado === true);
        setPrecioUnitarioPC(Pcoat.length > 0 ? true : false);
        setPrecioUnitario(Ecoat.length > 0 ? true : false);
        setPrecioUnitarioP(Platinado.length > 0 ? true : false);
        setInputList(list);
        //if (e.target.value) 


    };
    async function onChangeProducto(e, i) {
        const list = [...inputList];
        const { name, value } = e.target;
        var productosFromAPI = [];
        if (name === "productoID") {
            productosFromAPI = productosSinFiltro.filter(producto => producto.id === e.target.value);
        }

        if (name === "numerodeParte") {
            productosFromAPI = productosSinFiltro.filter(
                (producto) =>
                    producto.numerodeParte.toLowerCase().trim() ===
                    e.target.value.toLowerCase().trim()
            );
        }

        if (productosFromAPI.length > 0) {
            await Promise.all(productosFromAPI.map(async producto => {
                list[i].productoID = producto.id;
                list[i].parteValido = true;
                list[i].numerodeParte = producto.numerodeParte;
                list[i].descripcion = producto.descripcion;
                list[i].rackTipo = producto.rackTipo;
                list[i].piezasXRack = producto.piezasXRack;
                if (producto.Pcoat) {
                    list[i].Pcoat = producto.Pcoat;
                }
                if (producto.Ecoat) {
                    list[i].Ecoat = producto.Ecoat;
                }
                if (producto.Platinado) {
                    list[i].Platinado = producto.Platinado;
                }
                if (producto.precioUnitario) {
                    list[i].precioUnitario = producto.precioUnitario;
                    if (!producto.Ecoat) {
                        list[i].Ecoat = true;
                    }
                }
                if (producto.precioUnitarioP) {
                    list[i].precioUnitarioP = producto.precioUnitarioP;
                }
                if (producto.precioUnitarioPC) {
                    list[i].precioUnitarioPC = producto.precioUnitarioPC;
                }

                list[i].divisa = producto.divisa;
                if (verCantidadAlmacen === true) {
                    const rPorNumeroP = reciba.filter(rnumerop => (rnumerop.numerodeParte === producto.numerodeParte) &&
                        (rnumerop.clienteID === producto.clienteID)
                    );
                    var cantidadTNP = 0;
                    await Promise.all(rPorNumeroP.map(async reciba => {
                        cantidadTNP = cantidadTNP + (reciba.cantidadRecibida - (reciba.cantidadPlaneada ? reciba.cantidadPlaneada : 0));
                    }));
                    list[i].cantidadPiezas = cantidadTNP;
                }

                if ((list[i].cantidadPiezas ? list[i].cantidadPiezas : 0) > 0 && (producto.piezasXRack ? producto.piezasXRack : 0) > 0) {
                    list[i].racks = (list[i].cantidadPiezas && producto.piezasXRack) ? (parseFloat(list[i].cantidadPiezas) / parseFloat(producto.piezasXRack)).toFixed(2) : "";
                } else {
                    delete list[i].racks;
                }
            }));
        } else {
            list[i][name] = value;
            list[i].parteValido = false;
            list[i].productoID = "";
            delete list[i].piezasXRack;
            delete list[i].precioUnitario;
            delete list[i].precioUnitarioPC;
            delete list[i].precioUnitarioP;
            delete list[i].Pcoat;
            delete list[i].Ecoat;
            delete list[i].Platinado;
            delete list[i].divisa;
            delete list[i].racks;
            list[i].descripcion = "";
            list[i].rackTipo = "";

            delete list[i].cantidadPiezas;

        }
        const Pcoat = list.filter(proceso => proceso.Pcoat === true);
        const Ecoat = list.filter(proceso => proceso.Ecoat === true);
        const Platinado = list.filter(proceso => proceso.Platinado === true);
        setPrecioUnitarioPC(Pcoat.length > 0 ? true : false);
        setPrecioUnitario(Ecoat.length > 0 ? true : false);
        setPrecioUnitarioP(Platinado.length > 0 ? true : false);
        setInputList(list);
    };
    function onChangescheck(e, i, list) {
        const { name, checked } = e.target;
        list[i][name] = checked;

        const Pcoat = list.filter(proceso => proceso.Pcoat === true);
        const Ecoat = list.filter(proceso => proceso.Ecoat === true);
        const Platinado = list.filter(proceso => proceso.Platinado === true);
        setPrecioUnitarioPC(Pcoat.length > 0 ? true : false);
        setPrecioUnitario(Ecoat.length > 0 ? true : false);
        setPrecioUnitarioP(Platinado.length > 0 ? true : false);
        return list;
    }
    function handleRemoveClick(index, list) {
        if (!editar || !list[index].id)
            list.splice(index, 1);
        else
            list[index].activo = false;

        FaltanDatosPlaneacion(list);
        SumarRacksProduccion(list);
        return list;
    };
    function handleAddClick() {
        setInputList([...inputList, {
            fechaDePlaneacion: fechaPlaneacion, numero: 0, clienteID: '', productoID: '', cliente: '', numerodeParte: '', descripcion: '', rackTipo: '', prioridad: '1',
            prioridadAtencion: 'Urgente', cantidadPiezas: '', materialEnCantidad: 0, racks: '', ciclos: '1', activo: true, Reg_Ins_Usuario: '', Reg_Mod_Usuario: ''
        }]);
        setFaltanDatos(true);
    };
    function cancelarplaneacion() {
        setInputList([]);
        setEditar(false);
        updateFormState(() => ({ ...formState, formType: "PlaneaciónBase" }));
        setFechaPlaneacion("");
        fetchClientes();
        fetchPlaneaciones(rfechaini, rfechafin);
    };
    function SumarRacksProduccion(list) {
        var racks = 0;
        var ciclos = 0;
        list.map((planeacion, i) => {
            if (planeacion.activo) {
                if (planeacion.racks) {
                    racks += parseFloat(planeacion.racks);
                };
                if (planeacion.ciclos) {
                    ciclos += parseFloat(planeacion.ciclos);
                };
            };
        });
        setSumProduccionp(racks.toFixed(2) + " RACKS " + (racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN");
        setSumCiclos(ciclos + " CICLOS");
    };
    // handle input change
    function handleInputChange(e, index, list) {
        const { name, value } = e.target;
        const re = /^[0-9\.]+$/;
        if (e.target.value === '' || re.test(e.target.value) ||
            e.target.name === "comentarios" || e.target.name === "comentariosProduccion") {
            list[index][name] = value;
        }
        if (e.target.name === "racks") {
            SumarRacksProduccion(list);
        }
        if (e.target.name === "prioridad") {
            list[index].prioridadAtencion = value > 2 ? "Normal" : "Urgente";
        }

        if (e.target.name === "cantidadPiezas" && list[index].piezasXRack > 0) {
            list[index].racks = value > 0 ? (parseFloat(value) / parseFloat(list[index].piezasXRack ? list[index].piezasXRack : 0)).toFixed(2) : 0;
        }
        FaltanDatosPlaneacion(list);
        return list
    };
    // handle input change
    function handleInputChangeTexto(e, index, list) {
        const { name, value } = e.target;

        list[index][name] = value;

        FaltanDatosPlaneacion(list);
        return list
    };
    function clicEliminar() {
        setModal(!modal);
    };
    async function clicEditar() {
        setCargando(true);
        //Si existen registros        
        if (planeaciones.length) {
            //Se declara la variable tipo Array lista
            var lista = [];

            await Promise.all(planeaciones.map(async (planeacion, i) => {
                //Se obtiene la cantidad disponible tomando en cuenta los datos de la reciba sin filtros. 
                //Se obtiene el registro actualizado de los reciba seriales
                var oCantidadDisponible = planeacion.recibaSerialID ? planeacion.cantidadPiezas : 200000;
                //Se agrega 
                lista.push({
                    ...planeacion, cantidadDisponible: oCantidadDisponible, comentarios: planeacion.comentarios,
                    cantidadOriginal: planeacion.cantidadPiezas, prioridadOriginal: planeacion.prioridad,
                    racksOriginal: planeacion.racks, materialEnCantidadOriginal: planeacion.materialEnCantidad,
                    ciclosOriginal: planeacion.ciclos, updatedAt: planeacion.updatedAt
                })

            }));
            //Se obtiene el número de la planeación
            setNumeroP(planeaciones[0].numero);
            setInputList(lista);
            setFechaPlaneacion(planeaciones[0].fechaDePlaneacion);
            setVerCantidadAlmacen(false);
            setEditar(true);
            setFaltanDatos(false);
            SumarRacksProduccion(lista);
            //setSumProduccion()
            updateFormState(() => ({ ...formState, formType: "EditarPB" }));
        }
        setCargando(false);
    };
    function clicNuevaPlaneacion() {
        updateFormState(() => ({ ...formState, formType: "EditarPB" }));
        setFechaPlaneacion("");
        setInputList([]);
        setVerCantidadAlmacen(false);
        setEditar(false);
    };
    function clicPlaneacionBase() {
        updateFormState(() => ({ ...formState, formType: "EditarPB" }));
        setVerCantidadAlmacen(false);
        setFechaPlaneacion("");
        var lista = [];
        planeaciones.map(async (planeacion, i) => {
            //Se toma como base la planeación actual, para agregar los datos base.            
            lista.push({
                fechaDePlaneacion: "", numero: planeacion.numero, clienteID: planeacion.clienteID, rackTipo: planeacion.rackTipo,
                productoID: planeacion.productoID, cliente: planeacion.cliente, numerodeParte: planeacion.numerodeParte,
                Ecoat: planeacion.Ecoat, Pcoat: planeacion.Pcoat, precioUnitarioPC: planeacion.precioUnitarioPC,
                precioUnitario: planeacion.precioUnitario, divisa: planeacion.divisa, descripcion: planeacion.descripcion,
                prioridad: planeacion.prioridad, prioridadAtencion: planeacion.prioridadAtencion, cantidadPiezas: '',
                materialEnCantidad: 0, racks: '', ciclos: '1', activo: true, Reg_Ins_Usuario: '', Reg_Mod_Usuario: ''
            })

        });
        setInputList(lista);
        setEditar(false);
    };
    async function aceptarEliminar() {
        setModal(!modal);
        setAVisible(false);
        setCargando(true);
        try {
            var pConcurrencia = false;
            var problemasplanproduccion = false;
            var enProduccion = false;
            var numeropProduccion = 0;
            var pproduccionCF = [];
            var planeacionU = {};
            var PProduccionG = {};
            //Se obtienen los datos de la planeación por número para revisar la concurrencia
            let cfilter = { numero: { eq: planeaciones[0].numero } }
            const planeacionesFromAPI = await GetPlaneacionBase(cfilter);
            await Promise.all(planeaciones.map(async planeacion => {
                //Se revisa concurrencia en planeaciones
                const planeacionC = planeacionesFromAPI.filter(cplaneacion => cplaneacion.id === planeacion.id);
                if (planeacionC.length < 1) {//Si no se obtuvieron los datos, se marca como concurrencia
                    pConcurrencia = true;
                } else {//Si se encontraron datos, se comparan las fechas de última actualización para determinar si hay concurrencia.
                    if (planeacion.updatedAt !== planeacionC[0].updatedAt)
                        pConcurrencia = true;
                }
                //Se revisa si algún registro ya se encuentra en el plan de producción
                if (planeacion.cantidadPlanProduccion > 0)
                    enProduccion = true;
            }));

            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca activo igual a falso  en planeaciones
            if (pConcurrencia === false) {
                //Se actualizan los datos en reciba seriales y en planeación                
                await Promise.all(planeaciones.map(async (planeacion, i) => {
                    //Se actualizan los datos en la planeación
                    delete planeacion.paginacion;
                    delete planeacion.color;
                    delete planeacion.createdAt;
                    delete planeacion.updatedAt;
                    delete planeacion.__typename;
                    delete planeacion.cantidadDisponible;
                    planeacion.Reg_Mod_Usuario = userName;
                    planeacion.activo = false;
                    await API.graphql({ query: updatePlaneacionBase, variables: { input: planeacion } });
                }));

                //actualiza el registro general de la planeación                          
                const fplaneacionGeneralID = planeaciones.filter(planeacion => (planeacion.planeacionGeneralID ? planeacion.planeacionGeneralID : "") != "");
                if (fplaneacionGeneralID.length > 0) {
                    planeacionU = await GetPlaneacionBaseGeneralID(fplaneacionGeneralID[0].planeacionGeneralID);
                } else {
                    planeacionU = await GetPlaneacionBaseGeneral({ and: [{ numero: { eq: planeaciones[0].numero } }, { fechaDePlaneacion: { eq: planeaciones[0].fechaDePlaneacion } }, { activo: { eq: true } }] });
                    if (planeacionU.length > 0) {
                        planeacionU = PProduccionG[0];
                    }
                }

                if (planeacionU.id) {
                    const rPPlaneacion = { ...planeacionU, activo: false, Reg_Mod_Usuario: userName };
                    delete rPPlaneacion.createdAt;
                    delete rPPlaneacion.updatedAt;
                    delete rPPlaneacion.__typename;
                    setMensajeAlert("Problemas al actualizar el planeación general 2 " + JSON.stringify(rPPlaneacion));
                    await API.graphql({
                        query: updatePlaneacionBaseGeneral, variables: { input: rPPlaneacion }
                    });
                }
                window.scrollTo(0, 0);
                setMensajeAlert("Operación exitosa");
                setColor("primary");
                setAVisible(true);
                setCargando(false);
                fetchPlaneaciones(rfechaini, rfechafin);

            } else { //Si  hay concurrencia se tienen que actualizar los datos
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se recargaron los datos, favor de " +
                    " volver a intentarlo");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchPlaneaciones(rfechaini, rfechafin);
            }

        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }

    };
    function revisarCantidadValida(list) {
        var cantidadValida = true;
        list.map((planeacion, i) => {
            if (planeacion.cantidadDisponible < planeacion.cantidadPiezas || planeacion.cantidadPiezas == 0) {
                cantidadValida = false;
            };
        });
        return cantidadValida;
    }
    function FaltanDatosPlaneacion(list) {
        var fdatos = false;
        list.map((planeacion, i) => {
            if (planeacion.activo) {
                if (!planeacion.productoID || !planeacion.cliente || !planeacion.numerodeParte ||
                    !planeacion.prioridad || !planeacion.cantidadPiezas || !planeacion.racks || !planeacion.ciclos) {
                    fdatos = true;
                };
            };
        });
        setFaltanDatos(fdatos);
        return fdatos;
    };
    async function validacionesPlaneacion(list) {
        var fdatos = false;
        var cantidadValida = true;
        var iDSActivos = []
        list.map((planeacion, i) => {
            //Se revisa si faltan datos
            if (planeacion.activo) {
                if (!planeacion.productoID || !planeacion.cliente || !planeacion.numerodeParte ||
                    !planeacion.prioridad || !planeacion.cantidadPiezas || !planeacion.racks || !planeacion.ciclos) {
                    fdatos = true;
                };
            };
            //Se obtienen los ids de los registros activos
            if (planeacion.activo === true && planeacion.id) {
                iDSActivos.push({ id: planeacion.id })
            }
        });
        setFaltanDatos(fdatos);
        const resultado = { faltanDatos: fdatos, valido: cantidadValida, ids: iDSActivos }
        return resultado;
    };
    //Función para crear y guardar cambios de planeaciones
    async function managePlaneacion() {
        setAVisible(false);
        setCargando(true);
        setisDisabled(true);
        const revisarDatos = await validacionesPlaneacion(inputList);
        const faltandatosInput = revisarDatos.faltanDatos;
        //Se filtran loa datos del inputList, para obtener los que son nuevos o se modificaron        
        try {
            //Se revisa si faltan datos
            if (faltandatosInput || !fechaPlaneacion) {
                setMensajeAlert("Faltan datos o son erróneos: los campos marcados con un asterisco son obligatorios," +
                    " la cantidad del material agregado desde almacén no pude ser mayor a la cantidad disponible para su planeación," +
                    " la cantidad no puede ser cero." +
                    " Se marcan en rojo las cantidad errónea.");
                setColor("warning");
                setAVisible(true);
                setisDisabled(false);
                setCargando(false);
                window.scrollTo(0, 0);
            } else { //Si no faltan datos
                setMensajeAlert("No faltaron datos");
                var numeroUP = 1;
                var numeroPlaneacion = numeroP;
                //Se obtienen las planeaciones de la fecha elegida para validar que no existan mas de una del mismo día  
                var pConcurrencia = false;
                var planeacionf = [];
                var planeacionGeneralID = "";
                //________________________________________________
                //Se revisa si hay planeaciones con la misma fecha
                if (!editar) {
                    setMensajeAlert("Previo a obtener los datos de la planeación");
                    const apiDataf = await GetPlaneacionBaseGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { activo: { eq: true } }] });
                    planeacionf = apiDataf;
                    //Se revisa si ya existe una planeación con la fecha elegida, si ya existe una planeación del mismo día, 
                    //no se procede con la operación.
                    setMensajeAlert("Después a obtener los datos de la planeación");
                    if (planeacionf.length > 0) {
                        window.scrollTo(0, 0);
                        setMensajeAlert("No fue posible realizar la operación: Ya existe una Planeación con la fecha elegida, " +
                            "favor de elegir otra fecha y volver a intentarlo");
                        setColor("warning");
                        setCargando(false);
                        setAVisible(true);
                        setisDisabled(false);
                        return;
                    }
                } else {//Si es una actualización de datos.
                    //Se revisa si ya existe una planeación con la fecha elegida diferente al que se está editando.
                    setMensajeAlert("Previo de obtener la planeación 2");
                    const apiDataf = await GetPlaneacionBase({ or: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { numero: { eq: numeroP } }] });
                    planeacionf = apiDataf.filter(planeacion => planeacion.activo === true);
                    setMensajeAlert("Después de obtener la planeación 2");
                }
                //___________________________________________________________________
                setMensajeAlert("Antes de revisar concurrencia");
                var recibaDatosAc = {}
                //Se obtienen los datos y se revisa la concurrencia 
                await Promise.all(inputList.map(async (planeacion, i) => {
                    setMensajeAlert("Revisando concurrencia, i: " + i + " planeación:" + JSON.stringify(planeacion));
                    //Si existe id, se revisa la concurrencia en planeación                   
                    if (planeacion.id) {
                        //Se revisa si hay concurrencia en la planeación que se está editando.
                        //Se filtran los datos recien obtenidos por el número de planeación por el id de la planeación.
                        const planeacionesC = planeacionf.filter(planeacionfi => planeacionfi.id === planeacion.id);
                        //Se filtran los datos de planeaciones sin filtro por el número de planeación que se está editando.
                        if (planeacionesC.length < 1) {//Si no se obtuvieron los datos, se marca como concurrenci
                            pConcurrencia = true;
                            setMensajeAlert("Concurrencia en planeación 1");
                        } else {//Si se encuentra el dato, se revisa si hay concurrencia comparando el campo updatedAt de los datos obtenidos
                            if (planeacion.updatedAt !== planeacionesC[0].updatedAt) {
                                pConcurrencia = true;
                                setMensajeAlert("Concurrencia en planeación 2");
                            }
                        }
                    }
                    //Si se detectaron problemas, se termina el proceso de revisión.
                    if (pConcurrencia === true) {
                        return;
                    }
                }));
                //Si no se detectó concurencia,se procede con la operación.
                if (pConcurrencia === false) {
                    setMensajeAlert("Antes de insertar");
                    //Si no es editar, se intenta crear un nuevo número de planeación
                    if (!editar) {//Si es una inserción.                        
                        setMensajeAlert("Previo de obtener el último número");
                        //Si no existe otra planeación del mismo día, se procede a crear el nuevo número de la planeación en la tabla PlaneacionUltimoNumero
                        //Primero se obtienen los registro de la tabla PlaneacionUltimoNumeros                   
                        const apiData = await API.graphql({ query: listPlaneacionBaseUltimoNumeros, variables: { limit: 100000000 } });
                        const ultimapFromAPI = apiData.data.listPlaneacionBaseUltimoNumeros.items;
                        setMensajeAlert("Después de obtener el último número");
                        //Si se obtuvieron registros, se aumenta en 1 el campo "numero" que indica el número de la nueva planeación.
                        await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                            numeroUP = ultimaplaneacion.numero + 1;
                            ultimaplaneacion.numero = numeroUP;
                            delete ultimaplaneacion.createdAt;
                            delete ultimaplaneacion.updatedAt;
                            delete ultimaplaneacion.__typename;
                            ultimaplaneacion.fechaDePlaneacion = fechaPlaneacion;
                            ultimaplaneacion.Reg_Mod_Usuario = userName;
                            await API.graphql({ query: updatePlaneacionBaseUltimoNumero, variables: { input: ultimaplaneacion } })
                            return ultimaplaneacion;
                        }))
                        setMensajeAlert("Previo a crear el último número");
                        //Si no se obtuvieron registros, se crea un nuevo registro con el número de la planeación.
                        if (!ultimapFromAPI.length) {
                            await API.graphql({
                                query: createPlaneacionBaseUltimoNumero, variables: {
                                    input: {
                                        fechaDePlaneacion: fechaPlaneacion,
                                        numero: numeroUP, activo: true, Reg_Ins_Usuario: userName
                                    }
                                }
                            });
                        }
                        numeroPlaneacion = numeroUP;
                        setMensajeAlert("Después el último número");
                        //Se crea el registro de la planeación general
                        setMensajeAlert("Problemas al guardar la planeación general 1");
                        let resulpg = await API.graphql({
                            query: createPlaneacionBaseGeneral, variables: {
                                input: {
                                    fechaDePlaneacion: fechaPlaneacion,
                                    numero: numeroUP,
                                    activo: true,
                                    Reg_Ins_Usuario: userName
                                }
                            }
                        });
                        planeacionGeneralID = resulpg.data.createPlaneacionBaseGeneral.id;
                    } else {//Si es una edición.
                        //Se revisa si uno de los registros que se está editango tiene el 
                        const regPlaneaciong = inputList.filter(planeacion => planeacion.planeacionGeneralID);
                        if (regPlaneaciong.length > 0) {
                            planeacionGeneralID = regPlaneaciong[0].planeacionGeneralID;
                        } else {
                            //Se revisa si ya hay una planeación de la fecha y el número de planeación en cuestión
                            const planGeneral = await GetPlaneacionBaseGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { numero: { eq: numeroUP } }, { activo: { eq: true } }] });
                            if (planGeneral.length > 0) {
                                planeacionGeneralID = planGeneral[0].id;

                            } else {
                                //Se crea el registro de la planeación general
                                setMensajeAlert("Problemas al guardar la planeación general 1");
                                let resulpg = await API.graphql({
                                    query: createPlaneacionBaseGeneral, variables: {
                                        input: {
                                            fechaDePlaneacion: fechaPlaneacion,
                                            numero: numeroUP,
                                            activo: true,
                                            Reg_Ins_Usuario: userName
                                        }
                                    }
                                });
                                planeacionGeneralID = resulpg.data.createPlaneacionBaseGeneral.id;
                            }

                        }
                    }
                    //Se declaran variables auxiliares para obtener los ids de planeación y plan de producción.
                    var planeacionIDS = [];
                    //Se continúa con el proceso
                    await Promise.all(inputList.map(async (planeacion, i) => {
                        var planeacionesp = {}
                        //Se eliminan datos auxiliares
                        delete planeacion.autNoFIFO
                        delete planeacion.autPNoFIFOComentTIOA
                        delete planeacion.cantidadPlaneadaOriginal;
                        delete planeacion.cantidadDisponible;
                        delete planeacion.cantidadOriginal;
                        delete planeacion.prioridadOriginal;
                        delete planeacion.racksOriginal;
                        delete planeacion.materialEnCantidadOriginal;
                        delete planeacion.ciclosOriginal;
                        delete planeacion.updatedAt;
                        delete planeacion.parteValido;
                        delete planeacion.__typename;

                        //Se determina el orden del registro
                        if (planeacion.activo) {
                            planeacion.orden = i + 1;
                        }
                        //Si es una planeación nueva se crea el registro en planeación
                        if (!editar) {
                            planeacion.planeacionGeneralID = planeacionGeneralID;
                            planeacion.fechaDePlaneacion = fechaPlaneacion;
                            planeacion.Reg_Ins_Usuario = userName;
                            planeacion.numero = numeroUP;
                            planeacionesp.fechaHoraCreacion = Moment(new Date()).format("YYYY-MM-DD HH:mm");
                            planeacionesp.desdePproduccion = false;
                            setMensajeAlert("Problemas al crear el registro en planeación " + JSON.stringify(planeacion));
                            let resultadoc = await API.graphql({ query: createPlaneacionBase, variables: { input: planeacion } });
                            planeacionesp = await resultadoc.data.createPlaneacionBase;
                            planeacionIDS.push({ id: planeacionesp.id, nuevo: true, activo: true });
                        } else {
                            planeacion.fechaDePlaneacion = fechaPlaneacion;
                            if (planeacion.id) {
                                delete planeacion.createdAt;
                                delete planeacion.updatedAt;
                                delete planeacion.__typename;
                                delete planeacion.cantidadDisponible;
                                delete planeacion.paginacion;
                                delete planeacion.color;
                                delete planeacion.parteValido;
                                delete planeacion.fechaHoraCreacion;
                                delete planeacion.materialEn;
                                delete planeacion.piezasenPintado;
                                planeacion.Reg_Mod_Usuario = userName;

                                setMensajeAlert("Problemas al actualizar el registro en planeación " + JSON.stringify(planeacion));
                                let resultadoc = await API.graphql({ query: updatePlaneacionBase, variables: { input: planeacion } });
                                planeacionesp = await resultadoc.data.updatePlaneacionBase;
                                if (planeacion.activo === false) {
                                    planeacionIDS.push({ id: planeacionesp.id, nuevo: false, activo: false })
                                }
                            } else {
                                //Si es una modificación y es un nuevo registro, se pone la variable nuevo igual a true.   
                                planeacionesp.fechaHoraCreacion = Moment(new Date()).format("YYYY-MM-DD HH:mm");
                                planeacion.Reg_Ins_Usuario = userName;
                                planeacion.numero = numeroP;
                                planeacion.planeacionGeneralID = planeacionGeneralID;
                                setMensajeAlert("Problemas al crear el registro en planeación " + JSON.stringify(planeacion));
                                let resultadoc = await API.graphql({ query: createPlaneacionBase, variables: { input: planeacion } });
                                planeacionesp = await resultadoc.data.createPlaneacionBase;
                                planeacionIDS.push({ id: planeacionesp.id, nuevo: true, activo: true });
                            }
                            numeroPlaneacion = planeacion.numero;
                        }
                        setMensajeAlert("Planeación terminada");
                        return planeacion;
                    }));

                    //actualiza el registro general de la planeación                        
                    const planeacionU = await GetPlaneacionBaseGeneralID(planeacionGeneralID);

                    const planids = planeacionU.PlaneacionBIDS ? planeacionU.PlaneacionBIDS.length > 0 ? planeacionU.PlaneacionBIDS : [] : [];
                    const datosPPINDS = await combinarIDS(planids, planeacionIDS);

                    if (planeacionU.id) {
                        const rPPlaneacion = {
                            ...planeacionU,
                            fechaDePlaneacion: fechaPlaneacion,
                            PlaneacionBIDS: datosPPINDS,
                            activo: datosPPINDS.length > 0 ? true : false,
                            Reg_Mod_Usuario: userName
                        };
                        delete rPPlaneacion.createdAt;
                        delete rPPlaneacion.updatedAt;
                        delete rPPlaneacion.__typename;
                        setMensajeAlert("Problemas al actualizar el planeación general 2 " + JSON.stringify(rPPlaneacion));
                        await API.graphql({
                            query: updatePlaneacionBaseGeneral, variables: { input: rPPlaneacion }
                        });
                    }
                    //Se registran datos del resumen de operación.
                    const rOperacion = await manageResumenOperacion(fechaPlaneacion, inputList, "PlaneaciónBase", userName, planeacionGeneralID);

                    setMensajeAlert("Operación exitosa. ");
                    setisDisabled(false);
                    setColor("primary");
                    setAVisible(true);
                    setCargando(true);
                    fetchPlaneaciones(rfechaini, rfechafin);
                    setEditar(true);
                    updateFormState(() => ({ ...formState, formType: "PlaneaciónBase" }));
                    //setFechaPlaneacion("");
                    setCargando(false);
                } else {
                    window.scrollTo(0, 0);
                    /*setMensajeAlert("No fue posible realizar la operación: existe concurrencia. Se recargaron los datos,  favor de  " +
                        " volver a intentarlo");*/
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    setisDisabled(false);
                    fetchPlaneaciones(rfechaini, rfechafin);
                }
            }
        } catch (e) {
            window.scrollTo(0, 0);
            // setMensajeAlert(JSON.stringify(e.message));
            setColor("warning");
            setAVisible(true);
            setCargando(false);
            setisDisabled(false);
        }
    };
    //Revisa cambios en la fecha de búsqueda
    function onChangesRFechaP(e) {
        e.persist()
        var fechaini = rfechaini;
        var fechafin = rfechafin;
        if (e.target.name === "Irfechaini") {
            fechaini = e.target.value;
        } else {
            fechafin = e.target.value;
        }
        setRfechafin(fechafin);
        setRfechaini(fechaini);
        fetchPlaneaciones(fechaini, fechafin);
    }
    //Vista por número de parte
    function onChangescheckVNP(e) {
        window.scrollTo(0, 0);
        setCargando(true);
        setVistaNumeroParte(e.target.checked);
        busquedaPlaneacion(planeacionSinFiltro, currentPagePlaneacion, fechaPBusqueda, e.target.checked, verSeguimiento);
    }
    //Ver seguimiento en producción de planeación base
    function onChangescheckVS(e) {
        window.scrollTo(0, 0);
        setCargando(true);
        setVerSeguimiento(e.target.checked);
        busquedaPlaneacion(planeacionSinFiltro, currentPagePlaneacion, fechaPBusqueda, vistaNumeroParte, e.target.checked);
    }
    //Ver cantidad de almacén
    function onChangescheckCA(e) {
        window.scrollTo(0, 0);
        setCargando(true);
        setVerCantidadAlmacen(e.target.checked);
        fetchReciba();
    }
    //Indicador de vista del más actual al más antigüo en almacén
    function onChangescheckVUAP(e) {
        setVistaUltimoAP(e.target.checked);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, e.target.checked);
    }
    async function handleCallback(childData) {
        if (childData.completo === true) {
            fetchPlaneaciones(rfechaini, rfechafin);
        }
        if (childData.mensaje) {
            setMensajeAlert(childData.mensaje);
            setColor(childData.color)
            setAVisible(true);
        }

    };

    async function clicDescargarDatos() {
        try {
            setCargando(true);
            setAVisible(false);
            //Declaración de variables
            var planeacionBEXP = [];
            var planeacionesPD = planeaciones;
            //Se obtienen los datos en el orden requerido
            await Promise.all(
                planeacionesPD.map((planeacionreg, i) => {

                    //Se agregan los datos de la reciba
                    planeacionBEXP.push({
                        NÚMERO: i + 1,
                        CLIENTE: planeacionreg.cliente,
                        "NÚMERO DE PARTE": planeacionreg.numerodeParte,
                        "PRECIO UNITARIO": ((planeacionreg.divisa === "Peso mexicano" || planeacionreg.divisa === "Dólar") ? "$" : "€") + " " + planeacionreg.precioUnitario,
                        DESCRIPCIÓN: planeacionreg.descripcion,
                        "TIPO DE RACK": planeacionreg.rackTipo,
                        PRIORIDAD: planeacionreg.prioridadAtencion,
                        ATENCIÓN: planeacionreg.prioridad,
                        "RACKS": planeacionreg.racks,
                        "CANTIDAD": planeacionreg.cantidadPiezas,
                        "COSTO POR CORRIDA": ((planeacionreg.divisa === "Peso mexicano" || planeacionreg.divisa === "Dólar") ? "$" : "€") + " " + (planeacionreg.precioUnitario * (planeacionreg.cantidadPiezas)).toFixed(2),
                        "CONTENEDORES": planeacionreg.materialEnCantidad,
                        CICLOS: planeacionreg.ciclos,
                        "COMENTARIOS DE PLANEACIÓN BASE": planeacionreg.comentarios,
                        "COMENTARIOS PRODUCCIÓN": planeacionreg.comentariosProduccion,
                        "FECHA DE AGREGADO": Moment(planeacionreg.createdAt).format("DD/MM/YYYY"),
                    });

                    //
                    //return reciba
                })
            );

            var worksheet = xlsx.utils.json_to_sheet(planeacionBEXP);
            var workbook = xlsx.utils.book_new();
            xlsx.utils.book_append_sheet(workbook, worksheet, "Planeción Base");
            xlsx.writeFile(
                workbook,
                "Planeación base" + Moment(fechaPlaneacionM).format("DD-MM-YYYY") + ".xlsx"
            );
            setCargando(false);
        } catch (error) {
            window.scrollTo(0, 0);
            setMensajeAlert(JSON.stringify(error.message));
            setColor("warning");
            setAVisible(true);
            setCargando(false);
            setisDisabled(false);
        }
    }

    return (
        (pplaneacion === true || verpplaneacion === true || verpplaneacionbase === true) && (
            <>
                <div className="conteiner2">
                    <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                        {mensajeAlert}
                    </Alert>
                    {(cargando === true && verpplaneacionbase === false && pplaneacion === true) && (
                        <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                <img width="150px" alt="cargando" src="assets/img/preloader.gif" />
                            </div>
                        </Row>
                    )}
                    {formType === "PlaneaciónBase" && (
                        <>
                            {(pplaneacion === true || verpplaneacion === true) && (
                                <Row>
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                        {planeaciones.length > 0 && (<h5 className=" floatleft">Fecha de planeación {Moment(fechaPlaneacionM).format("DD/MM/YYYY")}</h5>)}
                                    </div>
                                    <div class="col-lg-2 col-md-6 col-sm-12 col-xs-12 text-left  margintop20px" >
                                        <FormGroup >
                                            <Label><h5>Búsqueda por fecha: </h5></Label>

                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text">
                                                        <input type="checkbox" checked={buscarporFecha} onChange={clicBuscarporFecha} />
                                                    </div>
                                                </div>
                                                <input type="date" class="form-control" onChange={onSearchFechaPlaneacion} value={fechaPBusqueda} disabled={!buscarporFecha} />
                                            </div>
                                        </FormGroup>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop10px" >
                                        {pplaneacion === true && (<button className="cbutton btn-danger floatright ml-2 " title="Eliminar" hidden={planeaciones.length ? false : true} disabled={verSeguimiento} onClick={() => { clicEliminar(); }}> Eliminar</button>)}
                                        {pplaneacion === true && (<button className="cbutton btn-warning floatright ml-2 " title="Descargar datos a excel" hidden={planeaciones.length ? false : true} disabled={verSeguimiento} onClick={() => { clicDescargarDatos("descarga"); }}>  <IoIcons.IoIosDownload /> Datos</button>)}
                                        {pplaneacion === true && (<button className="cbutton btn-primary floatright ml-2 " title="Editar" hidden={planeaciones.length ? false : true} disabled={verSeguimiento} onClick={() => { clicEditar(); }}> Editar</button>)}
                                        <button className="cbutton btn-info floatright ml-2 " title="Imprimir" hidden={planeaciones.length ? false : true} onClick={handlePrint}> Imprimir</button>
                                        {pplaneacion === true && (<button className="cbutton btn-success floatright  ml-2 margintopmobil10px marginrightmobil3p " title="Tomar como base planeación" onClick={() => { clicPlaneacionBase(); }}> <span className="fa fa-plus"></span>Base</button>)}
                                        {pplaneacion === true && (<button className="cbutton btn-success floatright  ml-2 margintopmobil10px marginrightmobil3p " title="Agregar nueva planeación" onClick={() => { clicNuevaPlaneacion(); }}> <span className="fa fa-plus"> </span>Nueva</button>)}
                                        <div className=" form-group row col-lg-12 col-md-12 col-sm-12 col-xs-12  floatrightleft ml-1">
                                            <div className="  col-lg-2 col-md-2 col-sm-12 col-xs-12  ml-3"></div>
                                            <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px   ml-1 ">
                                                <InputGroup>
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>Del:</InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input name="Irfechaini" type="date" value={Moment(rfechaini).format("YYYY-MM-DD")} onChange={onChangesRFechaP} />
                                                </InputGroup>
                                            </div>
                                            <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px  floatrightleft ml-1 ">
                                                <InputGroup className="floatrightleft ml-1">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>Al:</InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input name="Irfechafin" type="date" value={Moment(rfechafin).format("YYYY-MM-DD")} onChange={onChangesRFechaP} />
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                </Row>)}

                            <Row>
                                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 " >
                                    {(pplaneacion === true || verpplaneacion === true) && (<Label className="floatleft ml-2"><input type="checkbox" name="CNALiberado" onChange={onChangescheckVS} className='ml-2' />Ver seguimiento de pintado</Label>)}
                                    {(pplaneacion === false && verpplaneacion === false && verpplaneacionbase === true) && (<Label className="floatleft ml-3">Avence de producción </Label>)}

                                    {verSeguimiento === false && (
                                        <Label className="floatright  bg-warning">{"Urgente"}</Label>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 " >
                                    {(pplaneacion === true || verpplaneacion === true) && (<button className="cbutton btn-dark floatright  marginrightmobil3p margintop-10px " title="Recargar página" onClick={() => { fetchPlaneaciones(rfechaini, rfechafin); }}><IoIcons.IoMdRefresh /> Recargar </button>)}
                                    {(vpreciounitario === true && pplaneacion === true) && (
                                        <Label className="floatrightleft mr-2 ml-2"><input type="checkbox" name="checkMPU" onChange={(e) => setPrecioUnitarioIMP(e.target.checked)} className='ml-2' />Mostrar precio unitario en la impresión</Label>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 " >
                                    {verSeguimiento === true && (<>
                                        <Label className="floatleft ml-3 ">{"Ecoat "}</Label>
                                        <Label className="floatleft ml-2 bcolorr">{"0%"}</Label>
                                        <Label className="floatleft ml-2 bcolorbb ">{"<=25%"}</Label>
                                        <Label className="floatleft ml-2 bcolorlb">{">25% <=50%"}</Label>
                                        <Label className="floatleft ml-2 bcolorbg">{">50% <100%"}</Label>
                                        <Label className="floatleft ml-2 bcolordb">{">=100%"}</Label>
                                        <Label className="floatleft ml-2 bg-morado">{"Sin planificar"}</Label>
                                    </>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 " >
                                    {verSeguimiento === true && (<>
                                        <div className="floatrightleft">
                                            <Label className="floatleft ml-4 ">{"Powder"}</Label>
                                            <Label className="floatleft ml-4 bpcolorr">{"0%"}</Label>
                                            <Label className="floatleft ml-2 bpcolorbb ">{"<=25%"}</Label>
                                            <Label className="floatleft ml-2 bpcolorlb">{">25% <=50%"}</Label>
                                            <Label className="floatleft ml-2 bpcolorbg">{">50% <100%"}</Label>
                                            <Label className="floatleft ml-2 bpcolordb">{">=100%"}</Label>
                                            <Label className="floatleft ml-2 bgp-morado">{"Sin planificar"}</Label>
                                        </div>
                                    </>
                                    )}

                                </div>
                            </Row>
                            {/*JSON.stringify(modificados.value.data.onUpdatePlaneacionBase)*/}
                            <div >
                                <div className={((pplaneacion === true || verpplaneacion === true) && planeaciones.length > 20) ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                                    " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                                    <Table className=" mb-2 scroll " >
                                        <Thead class="thead-secondary">
                                            <Tr>
                                                <Th>Número</Th>
                                                <Th className="minwidth200px">Cliente</Th>
                                                <Th className="minwidth100px">Número de parte</Th>
                                                <Th className="minwidth80px">Proceso</Th>
                                                <Th className={(vpreciounitario === false || pplaneacion === false || precioUnitario === false) ? "displaynone" : "minwidth100px"}>Precio unitario Ecoat</Th>
                                                <Th className={(vpreciounitario === false || pplaneacion === false || precioUnitarioPC === false) ? "displaynone" : "minwidth100px"}>Precio unitario Pcoat</Th>
                                                {/*<Th className={(vpreciounitario === false || pplaneacion === false || precioUnitarioP === false) ? "displaynone" : "minwidth100px"}>Precio unitario Platinado</Th>*/}
                                                <Th className="minwidth100px">Descripción</Th>
                                                <Th className="minwidth100px">Tipo de Rack</Th>
                                                {vistaNumeroParte === false && (<>
                                                    <Th className="minwidth60px">Prioridad</Th>
                                                    <Th className="minwidth100px">Atención</Th>
                                                </>)}
                                                <Th>Racks</Th>
                                                <Th>Cantidad</Th>
                                                <Th class={(verSeguimiento === false) ? "displaynone" : "minwidth100px"}>
                                                    Piezas pintadas Ecoat
                                                </Th>
                                                <Th className={(verSeguimiento === false) ? "displaynone" : "minwidth100px"}>
                                                    Piezas aceptadas Ecoat
                                                </Th>
                                                <Th class={(verSeguimiento === false) ? "displaynone" : "minwidth100px"}>
                                                    Piezas no  aceptadas Ecoat
                                                </Th>
                                                <Th class={(vpreciounitario === false || pplaneacion === false) ? "displaynone" : "minwidth100px"}>
                                                    Costo por corrida
                                                </Th>
                                                {/*<Th>Material En</Th>*/}
                                                <Th>Contenedores</Th>
                                                {/*<Th>Paginación</Th>*/}
                                                <Th class="minwidth60px">Ciclos</Th>
                                                <Th>Comentarios PB</Th>
                                                <Th >Comentarios Producción</Th>
                                                <Th className={verSeguimiento === true ? "minwidth60px" : " displaynone minwidth60px"}>Avance pintado Ecoat</Th>
                                                <Th className={verSeguimiento === true ? "minwidth60px" : " displaynone minwidth60px"}>Avance Inspección final Ecoat</Th>
                                                <Th class={(verSeguimiento === false) ? "displaynone" : "minwidth100px"}>
                                                    Piezas pintadas PCoat
                                                </Th>
                                                <Th className={(verSeguimiento === false) ? "displaynone" : "minwidth100px"}>
                                                    Piezas aceptadas PCoat
                                                </Th>
                                                <Th class={(verSeguimiento === false) ? "displaynone" : "minwidth100px"}>
                                                    Piezas no  aceptadas PCoat
                                                </Th>
                                                <Th className={verSeguimiento === true ? "minwidth60px" : " displaynone minwidth60px"}>Avance pintado Pcoat</Th>
                                                <Th className={verSeguimiento === true ? "minwidth60px" : " displaynone minwidth60px"}>Avance Inspección final Pcoat</Th>
                                                <Th class="minwidth60px">Fecha de agregado</Th>
                                                <Th class="minwidth60px">Acciones</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {planeaciones.map((planeacion, i) => (
                                                <Tr class={verSeguimiento === true ?
                                                    (planeacion.prioridadAtencion === "Sin planificar" && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bg-morado" :
                                                        (planeacion.prioridadAtencion === "Sin planificar" && (planeacion.Pcoat === true)) ? "bgp-morado" :
                                                            (planeacion.piezasenPintadoPC === 0 && planeacion.Pcoat === true &&
                                                                (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorr" :
                                                                (planeacion.piezasenPintado === 0 && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorr" :
                                                                    (planeacion.piezasenPintadoPC <= (planeacion.cantidadPiezas / 4) && planeacion.Pcoat === true &&
                                                                        (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorbb" :
                                                                        (planeacion.piezasenPintado <= (planeacion.cantidadPiezas / 4) && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorbb" :
                                                                            (planeacion.piezasenPintadoPC <= (planeacion.cantidadPiezas / 2) && planeacion.Pcoat === true &&
                                                                                (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorlb" :
                                                                                (planeacion.piezasenPintado <= (planeacion.cantidadPiezas / 2) && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorlb" :
                                                                                    (planeacion.piezasenPintadoPC < (planeacion.cantidadPiezas) && planeacion.Pcoat === true &&
                                                                                        (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorbg" :
                                                                                        (planeacion.piezasenPintado < (planeacion.cantidadPiezas) && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorbg" :
                                                                                            (planeacion.piezasenPintadoPC >= planeacion.cantidadPiezas && planeacion.Pcoat === true &&
                                                                                                (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolordb" :
                                                                                                planeacion.piezasenPintado >= planeacion.cantidadPiezas ? "bcolordb" :
                                                                                                    planeacion.prioridadAtencion === "Urgente" ? "bg-warning" : planeacion.color
                                                    : planeacion.prioridadAtencion === "Urgente" ? "bg-warning" : planeacion.color} >
                                                    <Td>{i + 1}</Td>
                                                    <Td>{planeacion.cliente}</Td>
                                                    <Td>{planeacion.numerodeParte}</Td>
                                                    <Td className="margintopmobil20px">
                                                        <FormGroup >
                                                            {(planeacion.Ecoat === true) && (
                                                                <Label className="floatleft ">
                                                                    Ecoat
                                                                </Label>
                                                            )}
                                                            {(planeacion.Pcoat === true) && (
                                                                <Label className="floatleft ">
                                                                    Powder coat
                                                                </Label>
                                                            )}
                                                            {(planeacion.Platinado === true) && (
                                                                <Label className="floatleft">
                                                                    Platinado
                                                                </Label>
                                                            )}
                                                        </FormGroup>
                                                    </Td>
                                                    <Td className={(vpreciounitario === false || pplaneacion === false || precioUnitario === false) ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                                        {planeacion.Ecoat === true ? ((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " + (planeacion.precioUnitario ? planeacion.precioUnitario : "") : ""}
                                                    </Td>
                                                    <Td className={(vpreciounitario === false || pplaneacion === false || precioUnitarioPC === false) ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                                        {planeacion.Pcoat === true ? ((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " + (planeacion.precioUnitarioPC ? planeacion.precioUnitarioPC : "") : ""}
                                                    </Td>
                                                    {/*<Td className={(vpreciounitario === false || pplaneacion === false || precioUnitarioP === false) ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                                        {planeacion.Platinado === true ? ((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " + (planeacion.precioUnitarioP ? planeacion.precioUnitarioP : "") : ""}
                                                    </Td>*/}
                                                    <Td className="margintopmobil20px">{planeacion.descripcion}</Td>
                                                    <Td className={planeacion.descripcion ? "" : "margintopmobil20px"}>{planeacion.rackTipo}</Td>
                                                    {vistaNumeroParte === false && (<>
                                                        <Td className={planeacion.descripcion ? "" : "margintopmobil20px"} >{planeacion.prioridad}</Td>
                                                        <Td>{planeacion.prioridadAtencion}</Td>
                                                    </>)}
                                                    <Td className={vistaNumeroParte === true && !planeacion.descripcion ? "margintopmobil20px" : ""}  >{planeacion.racks}</Td>
                                                    <Td >{planeacion.cantidadPiezas}</Td>
                                                    <Td className={verSeguimiento === false ? "margintopmobil20px displaynone" : ""}  >{planeacion.piezasenPintado}</Td>
                                                    <Td className={verSeguimiento === false ? "margintopmobil20px displaynone" : ""}  >{planeacion.piezasCalidad}</Td>
                                                    <Td className={verSeguimiento === false ? "margintopmobil20px displaynone" : ""}  >{planeacion.piezasNoAceptadas}</Td>
                                                    <Td className={(vpreciounitario === false || pplaneacion === false) ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                                        {((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " +
                                                            ((planeacion.Ecoat === true ? (planeacion.precioUnitario * (planeacion.cantidadPiezas)) : 0) +
                                                                (planeacion.Pcoat === true ? (planeacion.precioUnitarioPC * (planeacion.cantidadPiezas)) : 0)).toFixed(2)}
                                                        {/* +(planeacion.Platinado === true ? (planeacion.precioUnitarioP * (planeacion.cantidadPiezas)) : 0) */}
                                                    </Td>
                                                    <Td >{planeacion.materialEnCantidad}</Td>
                                                    {/*<Td >{planeacion.materialEnCantidad}</Td>*/}
                                                    <Td >{planeacion.ciclos}</Td>
                                                    <Td >{planeacion.comentarios}</Td>
                                                    <Td >{planeacion.comentariosProduccion}</Td>
                                                    <Td className={verSeguimiento === true ? "margintopmobil20px" : "displaynone margintopmobil20px"}>{((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas) % 1 == 0 ?
                                                        ((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas) :
                                                        ((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas).toFixed(2)} %</Td>
                                                    <Td className={verSeguimiento === true ? "margintopmobil20px" : "displaynone margintopmobil20px"}>{planeacion.piezasenPintado ? (((planeacion.piezasCalidad + (planeacion.piezasNoAceptadas ? planeacion.piezasNoAceptadas : 0)) * 100) / planeacion.piezasenPintado) % 1 == 0 ?
                                                        (((planeacion.piezasCalidad + (planeacion.piezasNoAceptadas ? planeacion.piezasNoAceptadas : 0)) * 100) / planeacion.piezasenPintado) :
                                                        (((planeacion.piezasCalidad + (planeacion.piezasNoAceptadas ? planeacion.piezasNoAceptadas : 0)) * 100) / planeacion.piezasenPintado).toFixed(2) : 0} %</Td>
                                                    <Td className={verSeguimiento === false ? "margintopmobil20px displaynone" : ""}  >{planeacion.piezasenPintadoPC}</Td>
                                                    <Td className={verSeguimiento === false ? "margintopmobil20px displaynone" : ""}  >{planeacion.piezasCalidadPC}</Td>
                                                    <Td className={verSeguimiento === false ? "margintopmobil40px displaynone" : ""}  >{planeacion.piezasNoAceptadasPC}</Td>
                                                    <Td className={verSeguimiento === true ? "margintopmobil40px" : "displaynone margintopmobil20px"}>{((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas) % 1 == 0 ?
                                                        ((planeacion.piezasenPintadoPC * 100) / planeacion.cantidadPiezas) :
                                                        ((planeacion.piezasenPintadoPC * 100) / planeacion.cantidadPiezas).toFixed(2)} %</Td>
                                                    <Td className={verSeguimiento === true ? "margintopmobil20px" : "displaynone margintopmobil20px"}>
                                                        {planeacion.piezasenPintadoPC ? (((planeacion.piezasCalidadPC + (planeacion.piezasNoAceptadasPC ? planeacion.piezasNoAceptadasPC : 0)) * 100) / planeacion.piezasenPintadoPC) % 1 == 0 ?
                                                            (((planeacion.piezasCalidadPC + (planeacion.piezasNoAceptadasPC ? planeacion.piezasNoAceptadasPC : 0)) * 100) / planeacion.piezasenPintadoPC) :
                                                            (((planeacion.piezasCalidadPC + (planeacion.piezasNoAceptadasPC ? planeacion.piezasNoAceptadasPC : 0)) * 100) / planeacion.piezasenPintadoPC).toFixed(2) : 0} %</Td>

                                                    <Td className="margintopmobil20px">{Moment(planeacion.createdAt).format("DD/MM/YYYY")}</Td>
                                                    <Td className="margintopmobil20px" >
                                                        {(agregarComentariosPPB || pplaneacion) && (
                                                            <CometariosPB
                                                                planeacion={planeacion}
                                                                bColor={"primary "}
                                                                btitle={"Administrar comentarios"}
                                                                userName={userName}
                                                                tipo={(agregarComentariosPPB && pplaneacion) ? "Todo" :
                                                                    agregarComentariosPPB ? "PP" : pplaneacion ? "PB" : ""}
                                                                valorDeRetorno={handleCallback}
                                                            />
                                                        )}
                                                    </Td>
                                                </Tr>

                                            ))}
                                        </Tbody>
                                    </Table>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                                    <h5 class="floatcenter">{sumProduccion + "   " + sumICiclos + " " + ((vpreciounitario === true && pplaneacion === true) ? sumCostoTotal : "")}{verSeguimiento ? (". AVANCE PINTADO ECOAT " + sumPorcentajeT + "%" + " INSPECCIÓN FINAL ECOAT " + sumPorcentajeC + "%" +
                                        " AVANCE PINTADO PCOAT " + sumPorcentajeTPC + "%" + " INSPECCIÓN FINAL PCOAT " + sumPorcentajeCPC + "%"
                                    ) : ""}</h5>
                                </div>

                                <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 scroll ">
                                    {/*JSON.stringify(planeaciones)*/}
                                </div>
                            </div>
                            <Modal isOpen={modal} toggle={toggle}>
                                <ModalHeader toggle={toggle}>Eliminar planeación base</ModalHeader>
                                <ModalBody>
                                    ¿Estás seguro que quieres eliminar la planeacion base de la fecha {Moment(fechaPlaneacionM).format("DD/MM/YYYY")}?
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" onClick={aceptarEliminar}>Aceptar</Button>{' '}
                                    <Button color="danger" onClick={toggle}>Cancelar</Button>
                                </ModalFooter>
                            </Modal>
                            <div class="col-lg-12 col-md-12 col-sm-12  ">
                                <div class="floatcenter">
                                    <ul class="pagination">
                                        <li class={currentPagePlaneacion === 1 ? "page-item disabled" : "page-item"}>
                                            <a class="page-link" href="#" aria-label="Go to first page" onClick={() => handlePageChangePlaneacion(1)}>«</a>
                                        </li>
                                        <li class={currentPagePlaneacion === 1 ? "page-item disabled" : "page-item"}>
                                            <a class="page-link" href="#" aria-label="Go to previous page" onClick={() => handlePageChangePlaneacion(currentPagePlaneacion - 1)}>⟨</a>
                                        </li>
                                        {paginas.map(pagina => (
                                            ((pagina.pagina < currentPagePlaneacion + pageRange) && (pagina.pagina >= ((paginas.length - (pageRange - 1)) <
                                                ((currentPagePlaneacion + pageRange) - pageRange) ? (paginas.length - (pageRange - 1)) : ((currentPagePlaneacion + pageRange) - pageRange)))) && (
                                                <li class={currentPagePlaneacion === pagina.pagina ? "page-item active" : "page-item "}>
                                                    <a class="page-link " onClick={() => handlePageChangePlaneacion(pagina.pagina)}>{pagina.pagina}</a>
                                                </li>
                                            )
                                        ))}
                                        <li class={currentPagePlaneacion === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                                            <a class="page-link" href="#" aria-label="Go to next page" onClick={() => handlePageChangePlaneacion(currentPagePlaneacion + 1)}>⟩</a>
                                        </li>
                                        <li class={currentPagePlaneacion === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                                            <a class="page-link" href="#" aria-label="Go to last page" onClick={() => handlePageChangePlaneacion(ultimoNumeroP)}>»</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(planeacionSinFiltro)}</div>*/}
                            <div className='displaynone'>
                                <div ref={componentRef}  >
                                    <Row>
                                        <img className="imgmarlimp" alt="logo" src="assets/img/Logo/logost.png" />
                                        <div class="col-lg-12 col-md-12 col-sm-12 mt-2 margintop20px ">
                                            <h2 class=" textaligmentcenter ">Plan de producción /</h2>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 margintop-16px ">
                                            <h2 class="  textaligmentcenter  ">Requerimiento del cliente</h2>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop-16px  " >
                                            {planeaciones.length > 0 && (<h5 className=" floatright mr-3 bordersolid">{Moment(fechaPlaneacionM).format("DD/MM/YYYY")}</h5>)}
                                        </div>
                                    </Row>
                                    <div >
                                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                            <Table bordered className="margintop20px mb-2  fontsizeN20px " >
                                                <Thead >
                                                    <Tr>
                                                        {<Th className="thtableImprimir  fontsizeN20px textaligmentcenter">#</Th>}
                                                        <Th className="minwidth200px thtableImprimir  fontsizeN20px textaligmentcenter">CLIENTE</Th>
                                                        <Th className="minwidth200px thtableImprimir fontsizeN20px textaligmentcenter">Número de parte</Th>
                                                        <Th className="minwidth200px thtableImprimir fontsizeN20px textaligmentcenter">Descripción</Th>
                                                        <Th className="minwidth200px thtableImprimir fontsizeN20px textaligmentcenter">Tipo de Rack</Th>
                                                        <Th className={(precioUnitarioImp === false || precioUnitario === false) ? " displaynone" : "minwidth200px thtableImprimir fontsizeN20px textaligmentcenter"}>Precio unitario Ecoat</Th>
                                                        <Th className={(precioUnitarioImp === false || precioUnitarioPC === false) ? " displaynone" : "minwidth200px thtableImprimir fontsizeN20px textaligmentcenter"}>Precio unitario Powder coat</Th>
                                                        {/*<Th className={(precioUnitarioImp === false || precioUnitarioP === false) ? " displaynone" : "minwidth200px thtableImprimir fontsizeN20px textaligmentcenter"}>Precio unitario Platinado</Th>*/}
                                                        {vistaNumeroParte === false && (<>
                                                            <Th className="minwidth60px thtableImprimir fontsizeN20px textaligmentcenter">PRIORIDAD</Th>
                                                            {/*<Th className="thtableImprimir fontsizeN20px textaligmentcenter">Serial</Th>
                                                            <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Locación</Th>*/}
                                                        </>)}
                                                        <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Racks</Th>
                                                        <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Cantidad</Th>
                                                        <Th className={precioUnitarioImp === false ? " displaynone" : "minwidth200px thtableImprimir fontsizeN20px textaligmentcenter"}>Costo por corrida</Th>
                                                        <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Contenedores</Th>
                                                        <Th className="minwidth60px thtableImprimir fontsizeN20px textaligmentcenter">CICLOS</Th>
                                                        <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Comentarios PB</Th>
                                                        <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Comentarios Producción</Th>
                                                        {verSeguimiento && (<Th className="minwidth60px thtableImprimir fontsizeN20px textaligmentcenter">Avance</Th>)}
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {planeaciones.map((planeacion, i) => (
                                                        i < 31 && (
                                                            <Tr class={verSeguimiento === true ?
                                                                (planeacion.prioridadAtencion === "Sin planificar" && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bg-morado" :
                                                                    (planeacion.prioridadAtencion === "Sin planificar" && (planeacion.Pcoat === true)) ? "bgp-morado" :
                                                                        (planeacion.piezasenPintadoPC === 0 && planeacion.Pcoat === true &&
                                                                            (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorr" :
                                                                            (planeacion.piezasenPintado === 0 && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorr" :
                                                                                (planeacion.piezasenPintadoPC <= (planeacion.cantidadPiezas / 4) && planeacion.Pcoat === true &&
                                                                                    (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorbb" :
                                                                                    (planeacion.piezasenPintado <= (planeacion.cantidadPiezas / 4) && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorbb" :
                                                                                        (planeacion.piezasenPintadoPC <= (planeacion.cantidadPiezas / 2) && planeacion.Pcoat === true &&
                                                                                            (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorlb" :
                                                                                            (planeacion.piezasenPintado <= (planeacion.cantidadPiezas / 2) && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorlb" :
                                                                                                (planeacion.piezasenPintadoPC < (planeacion.cantidadPiezas) && planeacion.Pcoat === true &&
                                                                                                    (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorbg" :
                                                                                                    (planeacion.piezasenPintado < (planeacion.cantidadPiezas) && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorbg" :
                                                                                                        (planeacion.piezasenPintadoPC >= planeacion.cantidadPiezas && planeacion.Pcoat === true &&
                                                                                                            (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolordb" :
                                                                                                            planeacion.piezasenPintado >= planeacion.cantidadPiezas ? "bcolordb" :
                                                                                                                planeacion.prioridadAtencion === "Urgente" ? "bg-warning" : planeacion.color

                                                                : planeacion.prioridadAtencion === "Urgente" ? "bg-warning" : planeacion.color}>
                                                                <Td className="fontsizeN20px textaligmentcenter">{i + 1}</Td>
                                                                <Td className="fontsizeN20px textaligmentcenter">{planeacion.cliente}</Td>
                                                                <Td className="fontsizeN20px textaligmentcenter">{planeacion.numerodeParte}</Td>
                                                                <Td className="fontsizeN20px textaligmentcenter" >{planeacion.descripcion}</Td>
                                                                <Td className="fontsizeN20px textaligmentcenter" >{planeacion.rackTipo}</Td>
                                                                <Td className={(precioUnitarioImp === false || precioUnitario === false) ? " displaynone" : "fontsizeN20px textaligmentcenter"}>
                                                                    {planeacion.Ecoat == true ? ((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " + planeacion.precioUnitario : ""}
                                                                </Td>
                                                                <Td className={(precioUnitarioImp === false || precioUnitarioPC === false) ? " displaynone" : "fontsizeN20px textaligmentcenter"}>
                                                                    {planeacion.Pcoat == true ? ((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " + planeacion.precioUnitarioPC : ""}
                                                                </Td>
                                                                {/*<Td className={(precioUnitarioImp === false || precioUnitarioP === false) ? " displaynone" : "fontsizeN20px textaligmentcenter"}>
                                                                    {planeacion.Platinado == true ? ((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " + planeacion.precioUnitarioP : ""}
                                                                </Td>*/}
                                                                {vistaNumeroParte === false && (<>
                                                                    <Td className={planeacion.descripcion ? "fontsizeN20px textaligmentcenter" : "margintopmobil20px fontsizeN20px textaligmentcenter"} >{planeacion.prioridad}</Td>
                                                                    {/* <Td className="fontsizeN20px textaligmentcenter">{planeacion.serial}</Td>
                                                                    <Td className="fontsizeN20px textaligmentcenter">{planeacion.locacion}</Td>*/}
                                                                </>)}
                                                                <Td className={vistaNumeroParte === true && !planeacion.descripcion ? "margintopmobil20px fontsizeN20px textaligmentcenter" : "fontsizeN20px textaligmentcenter"}>{planeacion.racks}</Td>
                                                                <Td className="fontsizeN20px textaligmentcenter">{planeacion.cantidadPiezas}</Td>
                                                                <Td className={(precioUnitarioImp === false) ? " displaynone" : "fontsizeN20px textaligmentcenter"}>
                                                                    {((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " +
                                                                        ((planeacion.Ecoat === true ? (planeacion.precioUnitario * (planeacion.cantidadPiezas)) : 0) +
                                                                            (planeacion.Pcoat === true ? (planeacion.precioUnitarioPC * (planeacion.cantidadPiezas)) : 0)).toFixed(2)}
                                                                    {/* +(planeacion.Platinado === true ? (planeacion.precioUnitarioP * (planeacion.cantidadPiezas)) : 0)*/}
                                                                </Td>
                                                                <Td className="fontsizeN20px textaligmentcenter">{planeacion.materialEnCantidad}</Td>
                                                                <Td className="fontsizeN20px textaligmentcenter">{planeacion.ciclos}</Td>
                                                                <Td className="fontsizeN20px textaligmentcenter">{planeacion.comentarios}</Td>
                                                                <Td className="fontsizeN20px textaligmentcenter">{planeacion.comentariosProduccion}</Td>
                                                                {verSeguimiento && (<Td className="fontsizeN20px textaligmentcenter" >{((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas) % 1 == 0 ?
                                                                    ((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas) :
                                                                    ((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas).toFixed(2)} %</Td>)}
                                                            </Tr>)
                                                    ))}

                                                </Tbody>
                                            </Table>

                                            {planeaciones.length > 31 && (
                                                <>
                                                    <div className="page-break" >
                                                        <Table bordered className=" mb-2  fontsizeN20px " >
                                                            <Thead >
                                                                <Tr >
                                                                    {<Th className="thtableImprimir  fontsizeN20px textaligmentcenter">#</Th>}
                                                                    <Th className="minwidth200px thtableImprimir  fontsizeN20px textaligmentcenter">CLIENTE</Th>
                                                                    <Th className="minwidth200px thtableImprimir fontsizeN20px textaligmentcenter">Número de parte</Th>
                                                                    <Th className="minwidth200px thtableImprimir fontsizeN20px textaligmentcenter">Descripción</Th>
                                                                    <Th className="minwidth200px thtableImprimir fontsizeN20px textaligmentcenter">Tipo de Rack</Th>
                                                                    <Th className={(precioUnitarioImp === false || precioUnitario === false) ? " displaynone" : "minwidth200px thtableImprimir fontsizeN20px textaligmentcenter"}>Precio unitario Ecoat</Th>
                                                                    <Th className={(precioUnitarioImp === false || precioUnitarioPC === false) ? " displaynone" : "minwidth200px thtableImprimir fontsizeN20px textaligmentcenter"}>Precio unitario Powder coat</Th>
                                                                    {/*<Th className={(precioUnitarioImp === false || precioUnitarioP === false) ? " displaynone" : "minwidth200px thtableImprimir fontsizeN20px textaligmentcenter"}>Precio unitario Platinado</Th>*/}
                                                                    {vistaNumeroParte === false && (<>
                                                                        <Th className="minwidth60px thtableImprimir fontsizeN20px textaligmentcenter">PRIORIDAD</Th>
                                                                        {/*<Th className="thtableImprimir fontsizeN20px textaligmentcenter">Serial</Th>
                                                                        <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Locación</Th>*/}
                                                                    </>)}
                                                                    <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Racks</Th>
                                                                    <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Cantidad</Th>
                                                                    <Th className={precioUnitarioImp === false ? " displaynone" : "minwidth200px thtableImprimir fontsizeN20px textaligmentcenter"}>Costo por corrida</Th>
                                                                    <Th className="minwidth60px thtableImprimir fontsizeN20px textaligmentcenter">CICLOS</Th>
                                                                    <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Comentarios PB</Th>
                                                                    <Th className="thtableImprimir fontsizeN20px textaligmentcenter">Comentarios Producción</Th>
                                                                    {verSeguimiento && (<Th className="minwidth60px thtableImprimir fontsizeN20px textaligmentcenter">Avance</Th>)}
                                                                </Tr>
                                                            </Thead>
                                                            <Tbody>
                                                                {planeaciones.map((planeacion, i) => (
                                                                    i > 30 && (
                                                                        <Tr class={verSeguimiento === true ?
                                                                            (planeacion.prioridadAtencion === "Sin planificar" && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bg-morado" :
                                                                                (planeacion.prioridadAtencion === "Sin planificar" && (planeacion.Pcoat === true)) ? "bgp-morado" :
                                                                                    (planeacion.piezasenPintadoPC === 0 && planeacion.Pcoat === true &&
                                                                                        (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorr" :
                                                                                        (planeacion.piezasenPintado === 0 && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorr" :
                                                                                            (planeacion.piezasenPintadoPC <= (planeacion.cantidadPiezas / 4) && planeacion.Pcoat === true &&
                                                                                                (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorbb" :
                                                                                                (planeacion.piezasenPintado <= (planeacion.cantidadPiezas / 4) && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorbb" :
                                                                                                    (planeacion.piezasenPintadoPC <= (planeacion.cantidadPiezas / 2) && planeacion.Pcoat === true &&
                                                                                                        (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorlb" :
                                                                                                        (planeacion.piezasenPintado <= (planeacion.cantidadPiezas / 2) && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorlb" :
                                                                                                            (planeacion.piezasenPintadoPC < (planeacion.cantidadPiezas) && planeacion.Pcoat === true &&
                                                                                                                (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolorbg" :
                                                                                                                (planeacion.piezasenPintado < (planeacion.cantidadPiezas) && (planeacion.Ecoat === true || !planeacion.Pcoat)) ? "bcolorbg" :
                                                                                                                    (planeacion.piezasenPintadoPC >= planeacion.cantidadPiezas && planeacion.Pcoat === true &&
                                                                                                                        (!planeacion.Ecoat || planeacion.piezasenPintado >= planeacion.cantidadPiezas)) ? "bpcolordb" :
                                                                                                                        planeacion.piezasenPintado >= planeacion.cantidadPiezas ? "bcolordb" :
                                                                                                                            planeacion.prioridadAtencion === "Urgente" ? "bg-warning" : planeacion.color

                                                                            : planeacion.prioridadAtencion === "Urgente" ? "bg-warning" : planeacion.color}>
                                                                            <Td className="fontsizeN20px textaligmentcenter">{i + 1}</Td>
                                                                            <Td className="fontsizeN20px textaligmentcenter">{planeacion.cliente}</Td>
                                                                            <Td className="fontsizeN20px textaligmentcenter">{planeacion.numerodeParte}</Td>
                                                                            <Td className="fontsizeN20px textaligmentcenter" >{planeacion.descripcion}</Td>
                                                                            <Td className="fontsizeN20px textaligmentcenter" >{planeacion.rackTipo}</Td>
                                                                            <Td className={(precioUnitarioImp === false || precioUnitario === false) ? " displaynone" : "fontsizeN20px textaligmentcenter"}>
                                                                                {(planeacion.precioUnitario && planeacion.Ecoat === true) ? ((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " + planeacion.precioUnitario : ""}
                                                                            </Td>
                                                                            <Td className={(precioUnitarioImp === false || precioUnitarioPC === false) ? " displaynone" : "fontsizeN20px textaligmentcenter"}>
                                                                                {(planeacion.precioUnitarioPC && planeacion.Pcoat === true) ? ((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " + planeacion.precioUnitarioPC : ""}
                                                                            </Td>
                                                                            {/*<Td className={(precioUnitarioImp === false || precioUnitarioP === false) ? " displaynone" : "fontsizeN20px textaligmentcenter"}>
                                                                                {(planeacion.precioUnitarioP && planeacion.Platinado === true) ? ((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " + planeacion.precioUnitarioP : ""}
                                                                            </Td>*/}
                                                                            {vistaNumeroParte === false && (<>
                                                                                <Td className={planeacion.descripcion ? "fontsizeN20px textaligmentcenter" : "margintopmobil20px fontsizeN20px textaligmentcenter"} >{planeacion.prioridad}</Td>
                                                                                {/*<Td className="fontsizeN20px textaligmentcenter">{planeacion.serial}</Td>
                                                                                <Td className="fontsizeN20px textaligmentcenter">{planeacion.locacion}</Td>*/}
                                                                            </>)}
                                                                            <Td className={vistaNumeroParte === true && !planeacion.descripcion ? "margintopmobil20px fontsizeN20px textaligmentcenter" : "fontsizeN20px textaligmentcenter"}>{planeacion.racks}</Td>
                                                                            <Td className="fontsizeN20px textaligmentcenter">{planeacion.cantidadPiezas}</Td>
                                                                            <Td className={precioUnitarioImp === false ? " displaynone" : "fontsizeN20px textaligmentcenter"}>
                                                                                {((planeacion.divisa === "Peso mexicano" || planeacion.divisa === "Dólar") ? "$" : "€") + " " +
                                                                                    ((planeacion.Ecoat === true ? (planeacion.precioUnitario * (planeacion.cantidadPiezas)) : 0) +
                                                                                        (planeacion.Pcoat === true ? (planeacion.precioUnitarioPC * (planeacion.cantidadPiezas)) : 0)).toFixed(2)}
                                                                                {/*(planeacion.Platinado === true ? (planeacion.precioUnitarioP * (planeacion.cantidadPiezas)) : 0) */}
                                                                            </Td>
                                                                            <Td className="fontsizeN20px textaligmentcenter">{planeacion.ciclos}</Td>
                                                                            <Td className="fontsizeN20px textaligmentcenter">{planeacion.comentarios}</Td>
                                                                            <Td className="fontsizeN20px textaligmentcenter">{planeacion.comentariosProduccion}</Td>
                                                                            {verSeguimiento && (<Td className="fontsizeN20px textaligmentcenter" >{((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas) % 1 == 0 ?
                                                                                ((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas) :
                                                                                ((planeacion.piezasenPintado * 100) / planeacion.cantidadPiezas).toFixed(2)} %</Td>)}
                                                                        </Tr>)
                                                                ))}

                                                            </Tbody>
                                                        </Table>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1   ">
                                            <h5 class={precioUnitarioImp === true ? "margintop20px bordersolid comentpimpsl  " : "margintop20px bordersolid   comentpimp   "} >Comentarios: {sumProduccion}  {"   " + sumICiclos + " " + (precioUnitarioImp === true ? sumCostoTotal : "")}{verSeguimiento ? (". AVANCE PINTADO " + sumPorcentajeT + "%" + " INSPECCIÓN FINAL " + sumPorcentajeC + "%") : ""}</h5>
                                        </div>
                                        <Row className="mt-5">
                                            <h5 class="textaligmentcenter resppimp">Responsable:_________________________________ </h5>
                                            <h5 class="textaligmentcenter autppimp">Autorización:_________________________________ </h5>

                                        </Row>
                                        <div class="footer">
                                            <p className="floatright margintop-16px mr-3">Doc ID: FOR-MA17</p> <br />
                                            <p className="floatright margintop-16px mr-3">Revisión:  A</p> <br />
                                            <p className="floatright margintop-16px mr-3">Fecha:  13/SEP/2022</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>

                    )}
                    {formType === "EditarPB" && (
                        <>
                            <Fragment>
                                {/*numeroP*/}
                                <Row>
                                    <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6  margintop20px " >
                                        <h5 className="floatleft">Fecha de planeación*: </h5>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6  margintop20px floatleft " >
                                        <Input
                                            type="date"
                                            name="fechaDePlaneacion"
                                            onChange={(e) => setFechaPlaneacion(e.target.value)}
                                            value={fechaPlaneacion}
                                        />
                                    </div>
                                    {pplaneacion && (
                                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12  margintop20px " >
                                            <button className=" cbutton btn-success floatright" color="success" size="sm" title="Agregar datos nuevos" onClick={handleAddClick}> <span className="fa fa-plus"> Agregar datos</span> </button>
                                        </div>
                                    )}
                                </Row>
                                {inputList.length > 0 && (
                                    <>
                                        <Label className="floatleft ml-2 margintop20px"><input type="checkbox" name="CNALiberado" onChange={onChangescheckCA} className='ml-2' />Ver cantidad de Almacén</Label>
                                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                                            <Table className=" mb-2  ">
                                                <Thead class="thead-secondary">
                                                    <Tr>
                                                        <Th >No.</Th>
                                                        <Th className="minwidth200px">Cliente*</Th>
                                                        <Th className="minwidth100px">Número de parte*</Th>
                                                        <Th className="minwidth80px">Proceso</Th>
                                                        <Th className={(vpreciounitario === false || precioUnitario === false) ? " displaynone" : "minwidth100px"}>Precio unitario Ecoat</Th>
                                                        <Th className={(vpreciounitario === false || precioUnitarioPC === false) ? " displaynone" : "minwidth100px"}>Precio unitario Powder coat</Th>
                                                        {/*<Th className={(vpreciounitario === false || precioUnitarioP === false) ? " displaynone" : "minwidth100px"}>Precio unitario Platinado</Th>*/}
                                                        <Th className="minwidth100px">Descripción</Th>
                                                        <Th className="minwidth100px">Tipo de Rack</Th>
                                                        <Th className="minwidth60px">Prioridad*</Th>
                                                        <Th className="minwidth100px">Atención*</Th>
                                                        <Th>Racks*</Th>
                                                        <Th>Cantidad*</Th>
                                                        <Th>Contenedores*</Th>
                                                        <Th className="minwidth60px">Ciclos*</Th>
                                                        <Th className={vpreciounitario === false ? " displaynone" : "minwidth100px"}>Costo por corrida</Th>
                                                        <Th>Comentarios PB</Th>
                                                        <Th >Comentarios Producción</Th>
                                                        <Th className="width30px" > Eliminar </Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {inputList.map((x, i) => (
                                                        x.activo && (
                                                            <Tr className={x.prioridadAtencion === "Urgente" ? "bg-warning" : (i % 2) !== 0 ? "table-active" : ""}>
                                                                <Td>{i + 1}</Td>
                                                                <Td>{!x.recibaSerialID ?
                                                                    <select name="clienteID" className="floatleft custom-select" disabled={!pplaneacion} onChange={(e) => onChangeCliente(e, i)} >
                                                                        <option className="" value="" >Elige un cliente</option>
                                                                        {clientes.map(cliente => (
                                                                            <option className="" value={cliente.id} selected={x.cliente === cliente.cliente ? true : false}>{cliente.cliente}</option>
                                                                        ))}
                                                                    </select> :
                                                                    x.cliente
                                                                }
                                                                </Td>
                                                                <Td className={(x.parteValido === false || !x.numerodeParte) ? "margintopmobil40px select-editable novalido" : "margintopmobil40px select-editable"}>
                                                                    {
                                                                        <>
                                                                            <select name="productoID"
                                                                                className="floatleft custom-select"
                                                                                disabled={!pplaneacion}
                                                                                onChange={(e) => onChangeProducto(e, i)} >
                                                                                <option className="" value="" selected={x.productoID === '' ? true : false}></option>
                                                                                {productosSinFiltro.map(producto => ((x.clienteID === producto.clienteID && producto.activo === true) && (
                                                                                    <option value={producto.id} selected={x.productoID === producto.id ? true : false}> {producto.numerodeParte}</option>
                                                                                )))}
                                                                            </select>
                                                                            <input
                                                                                name="numerodeParte"
                                                                                maxLength={20}
                                                                                type="text"
                                                                                hidden={!pplaneacion}
                                                                                placeholder={x.parteValido === false ? "No válido" : ""}
                                                                                value={x.numerodeParte}
                                                                                onChange={(e) => onChangeProducto(e, i)}
                                                                            />
                                                                        </>
                                                                    }
                                                                </Td>
                                                                <Td className="margintopmobil20px">
                                                                    <FormGroup >
                                                                        {(x.Ecoat === true || x.Ecoat === false) && (
                                                                            <Label className="floatleft ">
                                                                                {/*<input type="checkbox" name="Ecoat" onChange={(e) => setInputList(onChangescheck(e, i, [...inputList,]))} checked={x.Ecoat} disabled={(!x.Pcoat && !x.Platinado && x.Ecoat === true) ? true : false} />*/}
                                                                                Ecoat
                                                                            </Label>
                                                                        )}
                                                                        {(x.Pcoat === true || x.Pcoat === false) && (
                                                                            <Label className="floatleft ">
                                                                                {/*<input type="checkbox" name="Pcoat" onChange={(e) => setInputList(onChangescheck(e, i, [...inputList,]))} checked={x.Pcoat} disabled={(!x.Ecoat && !x.Platinado && x.Pcoat === true) ? true : false} />*/}
                                                                                Powder coat
                                                                            </Label>
                                                                        )}
                                                                        {(x.Platinado === true || x.Platinado === false) && (
                                                                            <Label className="floatleft">
                                                                                {/*<input type="checkbox" name="Platinado" onChange={(e) => setInputList(onChangescheck(e, i, [...inputList,]))} checked={x.Platinado} disabled={(!x.Pcoat && !x.Ecoat && x.Platinado === true) ? true : false} />*/}
                                                                                Platinado
                                                                            </Label>
                                                                        )}
                                                                    </FormGroup>
                                                                </Td>
                                                                <Td className={(vpreciounitario === false || precioUnitario === false) ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                                                    {((x.divisa === "Peso mexicano" || x.divisa === "Dólar") ? "$" : "€") + " " + x.precioUnitario}
                                                                </Td>
                                                                <Td className={(vpreciounitario === false || precioUnitarioPC === false) ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                                                    {((x.divisa === "Peso mexicano" || x.divisa === "Dólar") ? "$" : "€") + " " + x.precioUnitarioPC}
                                                                </Td>
                                                                {/*<Td className={(vpreciounitario === false || precioUnitarioP === false) ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                                                    {((x.divisa === "Peso mexicano" || x.divisa === "Dólar") ? "$" : "€") + " " + x.precioUnitarioP}
                                                                </Td>*/}
                                                                <Td className="margintopmobil40px">
                                                                    {x.descripcion}
                                                                </Td>
                                                                <Td className="margintopmobil40px">
                                                                    {x.rackTipo}
                                                                </Td>
                                                                <Td className="margintopmobil20px">
                                                                    <select name="prioridad" className=" custom-select" disabled={!pplaneacion} onChange={e => setInputList(handleInputChange(e, i, [...inputList]))} >
                                                                        <option value="1" selected={x.prioridad == "1" ? true : false}>1</option>
                                                                        <option value="2" selected={x.prioridad == "2" ? true : false}>2</option>
                                                                        <option value="3" selected={x.prioridad == "3" ? true : false}>3</option>
                                                                        <option value="4" selected={x.prioridad == "4" ? true : false}>4</option>
                                                                        <option value="5" selected={x.prioridad == "5" ? true : false}>5</option>
                                                                        <option value="6" selected={x.prioridad == "6" ? true : false}>6</option>
                                                                        <option value="7" selected={x.prioridad == "7" ? true : false}>7</option>
                                                                        <option value="8" selected={x.prioridad == "8" ? true : false}>8</option>
                                                                        <option value="9" selected={x.prioridad == "9" ? true : false}>9</option>
                                                                        <option value="10" selected={x.prioridad == "10" ? true : false}>10</option>
                                                                        <option value="11" selected={x.prioridad == "11" ? true : false}>11</option>
                                                                        <option value="12" selected={x.prioridad == "12" ? true : false}>12</option>
                                                                        <option value="13" selected={x.prioridad == "13" ? true : false}>13</option>
                                                                        <option value="14" selected={x.prioridad == "14" ? true : false}>14</option>
                                                                        <option value="15" selected={x.prioridad == "15" ? true : false}>15</option>
                                                                    </select>
                                                                </Td>
                                                                <Td className="margintopmobil20px">
                                                                    <select name="prioridadAtencion" className=" custom-select" disabled={!pplaneacion} onChange={e => setInputList(handleInputChangeTexto(e, i, [...inputList]))} >
                                                                        <option value="Normal" selected={x.prioridadAtencion == "Normal" ? true : false}>Normal</option>
                                                                        <option value="Urgente" selected={x.prioridadAtencion == "Urgente" ? true : false}>Urgente</option>
                                                                    </select>
                                                                </Td>
                                                                <Td className={(!x.racks || parseFloat(x.racks) <= 0) ? "margintopmobil20px novalido" : "margintopmobil20px"}>
                                                                    <Input name="racks" value={x.racks} disabled={!pplaneacion} onChange={e => setInputList(handleInputChange(e, i, [...inputList]))} placeholder="" />
                                                                </Td>
                                                                <Td className={x.cantidadDisponible < x.cantidadPiezas || x.cantidadPiezas == 0 ? "margintopmobil20px novalido" : "margintopmobil20px"}>
                                                                    <Input name="cantidadPiezas" value={x.cantidadPiezas} disabled={!pplaneacion} onChange={e => setInputList(handleInputChange(e, i, [...inputList]))} placeholder="" />
                                                                </Td>
                                                                <Td className="margintopmobil20px">
                                                                    <Input name="materialEnCantidad" value={x.materialEnCantidad} disabled={!pplaneacion} onChange={e => setInputList(handleInputChange(e, i, [...inputList]))} placeholder="" />
                                                                </Td>
                                                                <Td className="margintopmobil20px">
                                                                    <Input name="ciclos" value={x.ciclos} disabled={!pplaneacion} onChange={e => setInputList(handleInputChange(e, i, [...inputList]))} placeholder="" />
                                                                </Td>
                                                                <Td className={vpreciounitario === false ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                                                    {((x.divisa === "Peso mexicano" || x.divisa === "Dólar") ? "$" : "€") + " " +
                                                                        ((x.Ecoat === true ? (x.precioUnitario * (x.cantidadPiezas)) : 0) +
                                                                            (x.Pcoat === true ? (x.precioUnitarioPC * (x.cantidadPiezas)) : 0) +
                                                                            (x.Platinado === true ? (x.precioUnitarioP * (x.cantidadPiezas)) : 0)).toFixed(2)}
                                                                </Td>
                                                                <Td className="margintopmobil20px">
                                                                    <Input name="comentarios"
                                                                        disabled={!pplaneacion}
                                                                        type="textarea"
                                                                        rows="1"
                                                                        value={x.comentarios}
                                                                        onChange={e => setInputList(handleInputChange(e, i, [...inputList]))} placeholder="" />
                                                                </Td>
                                                                <Td className="margintopmobil20px">
                                                                    <Input name="comentariosProduccion"
                                                                        disabled={!agregarComentariosPPB}
                                                                        type="textarea"
                                                                        rows="1"
                                                                        value={x.comentariosProduccion}
                                                                        onChange={e => setInputList(handleInputChange(e, i, [...inputList]))} placeholder="" />
                                                                </Td>
                                                                <Td className="margintopmobil20px">
                                                                    {pplaneacion && (
                                                                        <Button
                                                                            className=" "
                                                                            title="Eliminar planeación"
                                                                            size="sm"
                                                                            color="danger"
                                                                            onClick={() => setInputList(handleRemoveClick(i, [...inputList]))}><IoIcons.IoMdClose />
                                                                        </Button>
                                                                    )}
                                                                </Td>
                                                            </Tr>
                                                        )))}
                                                </Tbody>
                                            </Table>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                                            <h5 class="floatcenter mr-3">{sumProduccionp}</h5>
                                            <h5 class="floatcenter ml-3">{sumCiclos}</h5>
                                        </div>
                                    </>
                                )}
                                <Row>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">
                                        <Button className="floatright" onClick={cancelarplaneacion} color="danger" >
                                            Cancelar
                                        </Button>
                                        <Button className="floatright" onClick={() => managePlaneacion()} disabled={isDisabled} color="primary" hidden={inputList.length > 0 ? false : true} >
                                            Guardar
                                        </Button>
                                    </div>
                                </Row>
                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(recibaSinFiltro)}</div>*/}
                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(modificados)}</div>*/}
                            </Fragment>
                        </>
                    )}
                </div>
            </>
        )
    )
};



export default PlaneacionB